import { APP_CONSTANTS } from 'src/app/constants/constants';
import { Component, EventEmitter, Input, Output, OnInit, ViewChild, TemplateRef } from '@angular/core';
import * as ApexCharts from 'apexcharts';
import { CommonService } from 'src/app/services/common/common.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';

@Component({
	selector: 'app-opp-differential-analysis',
	templateUrl: './opp-differential-analysis.component.html',
	styleUrls: ['./opp-differential-analysis.component.scss']
})
export class OppDifferentialAnalysisComponent implements OnInit {
  APP_CONSTANTS = APP_CONSTANTS;

    user_details: any;
    user_role: any = "";
	// @Input() opportunities_data: any;
	@Input() page_name: any;
	@Input() selected_opportunity_period: any;

	@Output() selectedOpportunityPeriodChanged = new EventEmitter<any>();
	@Output() stateChanged = new EventEmitter<any>();

	constructor(
		private storageService: StorageService,
		public commonService: CommonService,
		private dialog: MatDialog,
	) {}

	ngOnInit(): void {
		this.user_details = this.storageService.get("user_details");

		// this.user_details.is_book_optimized = false;

		if (this.user_details.role.role == 4) {
			this.user_role = "Advisor Manager";
			this.opp_risks_data = this.advisor_manager_opp_risks_data;
		}  else if (this.user_details.role.role == 5) {
			this.user_role = "Advisor";
			if (this.user_details.is_book_optimized == true) {
				this.opp_risks_data = this.advisor_opp_risks_data;
			} else {
				this.opp_risks_data = [this.advisor_opp_risks_data[4], this.advisor_opp_risks_data[5]];
			}
		} else if (this.user_details.role.role == 6) {
			this.user_role = "AFA";
			if (this.user_details.is_book_optimized == true) {
				this.opp_risks_data = this.afa_opp_risks_data;
			} else {
				this.opp_risks_data = [this.afa_opp_risks_data[3], this.afa_opp_risks_data[4]];
			}
		} else if (this.user_details.role.role == 8) {
			this.user_role = "Relationship Manager";
			this.opp_risks_data = this.relationship_manager_opp_risks_data;
		} else if (this.user_details.role.role == 11) {
			this.user_role = "Marketing Team";
			this.opp_risks_data = this.marketing_team_opp_risks_data;
		} else if (this.user_details.role.role == 13) {
			this.user_role = "Lending Officer";
			this.opp_risks_data = this.lending_officer_opp_risks_data;
		} else if (this.user_details.role.role == 14) {
			this.user_role = "Insurance Agent";
			this.opp_risks_data = this.insurance_agent_opp_risks_data;
		}


		// if (this.user_details.is_book_optimized == true) {
		// 	if (this.user_details.role.role == 4) {
		// 		this.user_role = "Advisor Manager";
		// 		this.opp_risks_data = this.advisor_manager_opp_risks_data;
		// 	}  else if (this.user_details.role.role == 5) {
		// 		this.user_role = "Advisor";
		// 		this.opp_risks_data = this.advisor_opp_risks_data;
		// 	} else if (this.user_details.role.role == 6) {
		// 		this.user_role = "AFA";
		// 		this.opp_risks_data = this.afa_opp_risks_data;
		// 	} else if (this.user_details.role.role == 8) {
		// 		this.user_role = "Relationship Manager";
		// 		this.opp_risks_data = this.relationship_manager_opp_risks_data;
		// 	}
		// } else {
		// 	if (this.user_details.role.role == 4) {
		// 		this.user_role = "Advisor Manager";
		// 		this.opp_risks_data = [this.advisor_manager_opp_risks_data[3]];
		// 	}  else if (this.user_details.role.role == 5) {
		// 		this.user_role = "Advisor";
		// 		this.opp_risks_data = [this.advisor_opp_risks_data[4]];
		// 	} else if (this.user_details.role.role == 6) {
		// 		this.user_role = "AFA";
		// 		this.opp_risks_data = [this.afa_opp_risks_data[3]];
		// 	} else if (this.user_details.role.role == 8) {
		// 		this.user_role = "Relationship Manager";
		// 		this.opp_risks_data = [this.relationship_manager_opp_risks_data[3]];
		// 	}
		// }

		// if (this.selected_opportunity_period == null) {
		// 	this.selected_opportunity_period = 0;
		// }

		// setTimeout(() => {
		// 	this.createUpsideOpportunityGraph();
		// 	this.createRetentionOpportunityGraph();
		// }, 200);

		this.getOpportunutiesData();

	}

	opportunities_data: any;
	opportunities_data_loaded: boolean = true;
	getOpportunutiesData() {
		this.opportunities_data_loaded = false;
		let route: any = "";
		if (this.user_role == "Advisor Manager") {
			route = '/advisormanagerdashboardopp/' + this.selected_opportunity_period + '/';
		} else if (this.user_role == "Advisor") {
			route = '/advisordashboardopp/' + this.selected_opportunity_period + '/';
		} else if (this.user_role == "AFA") {
			route = '/afadashboardopp/' + this.selected_opportunity_period + '/';
		} else if (this.user_role == "Relationship Manager") {
			route = '/advisordashboardopp/' + this.selected_opportunity_period + '/';
		} else if (this.user_role == "Marketing Team") {
			route = '/mtdashboardopp/' + this.selected_opportunity_period + '/';
		} else if (this.user_role == "Lending Officer") {
			route = '/advisordashboardopp/' + this.selected_opportunity_period + '/';
		} else if (this.user_role == "Insurance Agent") {
			route = '/advisordashboardopp/' + this.selected_opportunity_period + '/';
		}
		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.opportunities_data = res["optimization_opportunities"];
				this.opportunities_data_loaded = true;
				this.opportunityPeriodChanged(this.selected_opportunity_period);
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	opportunityPeriodChanged(value) {
		this.selected_opportunity_period = value;
		let data = JSON.parse(JSON.stringify(this.selected_opportunity_period));
		// if (this.selected_opportunity_period == 0) {
		// 	data = null;
		// }
		this.selectedOpportunityPeriodChanged.emit(data);
	}

	changePageState(section, type) {
		let data: any = {
			clickable: true,
			name: "",
		};
		if (section.clickable == true) {
			if (type == 'analysis') {
				data.name = section.show_analysis_name;
			} else {
				data.name = section.name;
			}

			this.stateChanged.emit(data);
		} else {
			if (type == 'analysis') {
				data.name = section.show_analysis_name;
				this.stateChanged.emit(data);
			}
		}
	}

	opp_risks_data: any = [];
	advisor_manager_opp_risks_data: any = [
		{
			name: 'Upside Opportunities',
			sub_name: 'Predicted Opp',
			key: 'upside_opp_count',
			sub_key: 'upside_opp_value',
			clickable: false,
			show_analysis: true,
			show_analysis_name: 'Upside Opportunities Analysis',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					name: "The definition for the section detailing the total upside opportunities within an advisor's existing book of business can be broken down into several parts for clarity:",
					sub_sections: [
						{
							name: "Overview",
							value: "This section is crafted to enlighten advisors on the breadth of untapped opportunities residing within their current book of business. It's a strategic tool designed to spotlight potential areas of growth and client engagement."
						},
						{
							name: "Trigger Event Business Rules",
							value: "Incorporated within this are opportunities unearthed through trigger event business rules. These rules are a curated set of indicators developed by industry experts. They signal the optimal moments and rationales for when a client might be inclined to invest in the next recommended product."
						},
						{
							name: "AI-Driven Opportunities",
							value: "Additionally, the section includes AI-driven opportunities that would typically go unnoticed without the intervention of advanced analytics. This AI model is a powerful asset, extending the advisor's insight beyond traditional methods and revealing hidden prospects for client investment."
						},
						{
							name: "Navigation",
							value: "Advisors can navigate through these opportunities by clicking on the indicated arrow. This action unfolds a detailed breakdown, categorizing opportunities by their origin—be it AI-generated or triggered by specific events. It also segments them based on their propensity to close promptly and their estimated value."
						},
						{
							name: "Ranking System",
							value: "Crucially, all opportunities are ranked to assist advisors in prioritizing their efforts. This ranking is meticulously designed to steer advisors towards opportunities that not only possess high value but also exhibit a shorter timespan for deal closure."
						},
						{
							name: "Purpose",
							value: "The ultimate goal of this section is to equip advisors with a prioritized, insightful view of their book of business, enabling them to concentrate on the most promising and lucrative opportunities for expanding their client's investment portfolio. It's a blend of expert knowledge and machine learning precision, all tailored to enhance the advisor's efficiency and success rate."
						},
					]
				},
			],
			image: "assets/upside_icon.png"
		},
		{
			name: 'Retention Opportunities',
			sub_name: 'Predicted Loss',
			key: 'retention_count',
			sub_key: 'retention_value',
			clickable: false,
			show_analysis: true,
			show_analysis_name: 'Retention Opportunities Analysis',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					name: "The client retention risk section has been designed with a multi-faceted approach to ensure that advisors have a clear and actionable understanding of potential risks within their client base:",
					sub_sections: [
						{
							name: "Section Purpose",
							value: "The purpose of this section is to equip advisors with in-depth knowledge of the risks associated with client retention in their existing portfolios. It's a critical tool aimed at preempting client turnover and fostering long-term loyalty."
						},
						{
							name: "Trigger Event Business Rules Component",
							value: "At the core of this section are the trigger event business rules. These are insights developed by seasoned industry experts that signal potential client departure scenarios. They serve as an early warning system, indicating the possible reasons a client may be contemplating ending their financial services relationship."
						},
						{
							name: "AI-Driven Risk Detection",
							value: "Beyond conventional wisdom, the section is enhanced with AI-driven insights. This sophisticated analysis surfaces risks that would be undetectable without the advanced capabilities of AI, thus offering a deeper understanding of client sentiment and potential disengagement."
						},
						{
							name: "Detailed Risk Analysis",
							value: "Advisors can access a comprehensive breakdown of these risks by interacting with the section. A simple click reveals a detailed categorization of the risks by origin and potential impact. This feature provides a clear view of which clients are at risk and the urgency of addressing their concerns, potentially opening avenues to not only retain but also to expand business with them."
						},
						{
							name: "Prioritization of Risks",
							value: "The risks are prioritized and ranked according to severity and the timeframe within which they may affect the business. This system allows advisors to anticipate and act on retention challenges well in advance, with a 2 to 3-year lead time for strategic action and relationship reinforcement."
						},
						{
							name: "Strategic Benefits",
							value: "This section is more than just a list of risks; it's a strategic asset. It offers the advisors a chance to take preemptive actions based on a comprehensive, data-driven understanding of their client base. By focusing on the highest-ranked risks, advisors can not only secure their business against potential loss but also identify opportunities for additional engagement and revenue through tailored cross-selling strategies."
						},
					]
				},
			],
			image: "assets/retention_icon.png"
		},
		// {
		// 	name: 'Reassignment - AI Advisor Assistant',
		// 	name: 'Reassignment - MAGI',
		// 	sub_name: 'Predicted Opp',
		//  sub_name: 'Invested AUM',
		// 	key: 'ai_assistant_count',
		// 	sub_key: 'ai_assistant_value',
		// 	clickable: false,
    // format_number: true,
		// 	tooltip: true,
		// 	show_analysis: false,
		// 	show_analysis_name: 'Reassignment - AI Advisor Assistant Analysis',
		// 	show_analysis_name: 'Reassignment - MAGI Analysis',
		// 	tooltipText: [
		// 		{
		// 			name: "This section is designed to enhance the efficiency and effectiveness of advisors by leveraging AI technology:",
		// 			sub_sections: [
		// 				{
		// 					name: "Section Purpose",
		// 					value: "This section is created to identify clients within an advisor's book of business who are suitable candidates for reassignment to the AI Advisor Assistant. The objective is to streamline the advisor's workflow, significantly reducing daily tasks by 30 to 60%."
		// 				},
		// 				{
		// 					name: "Benefits of Reassignment",
		// 					value: "By reallocating certain clients to the AI Advisor Assistant, advisors can optimize their schedules, allowing them to expand their clientele and elevate the quality of service offered to existing clients. This transition is designed to retain the full spectrum of service benefits while simultaneously granting advisors additional bandwidth for client engagement and business development."
		// 					value: "By reallocating certain clients to the MAGI, advisors can optimize their schedules, allowing them to expand their clientele and elevate the quality of service offered to existing clients. This transition is designed to retain the full spectrum of service benefits while simultaneously granting advisors additional bandwidth for client engagement and business development."
		// 				},
		// 				{
		// 					name: "AI Advisor Assistant Capabilities",
		// 					name: "MAGI Capabilities",
		// 					value: "The AI Advisor Assistant is an advanced system, an amalgam of various AI models, each specializing in distinct areas of client management. These models include:",
		// 					value: "The MAGI is an advanced system, an amalgam of various AI models, each specializing in distinct areas of client management. These models include:",
		// 					sub_sections: [
		// 						{
		// 						  name: "Best Client Interaction Strategy",
		// 						  value: "Tailored communication tactics to engage clients effectively."
		// 						},
		// 						{
		// 							name: "Upside Opportunities Identification",
		// 							value: "Recognition of potential areas for financial growth within the client's portfolio."
		// 						},
		// 						{
		// 							name: "Retention Risk Analysis",
		// 							value: "Detection of signals that may indicate a client is at risk of ending their services."
		// 						},
		// 					]
		// 				},
		// 				{
		// 					name: "Training and Performance",
		// 					value: "This feature has undergone extensive training, modeling its approach on the patterns and strategies of high-performing advisors. It analyzes how successful advisors respond to leads and manage retention risks, applying these best practices autonomously to manage routine tasks and client interactions."
		// 				},
		// 				{
		// 					name: "Automation and Efficiency",
		// 					value: "The AI Advisor Assistant is a testament to the power of automation, embodying the capability to take over a substantial portion of the advisor's operational duties. This allows for a more focused and strategic allocation of the advisor's time and expertise, ensuring that clients receive top-tier advisory services while the advisor's practice becomes more scalable and efficient."
		// 					value: "The MAGI is a testament to the power of automation, embodying the capability to take over a substantial portion of the advisor's operational duties. This allows for a more focused and strategic allocation of the advisor's time and expertise, ensuring that clients receive top-tier advisory services while the advisor's practice becomes more scalable and efficient."
		// 				},
		// 			]
		// 		},
		// 	],
		// 	image: "assets/ai_assistant_icon.png"

		// },
		// {
		// 	// name: 'Reassignment - Associate Financial Advisor',
		// 	// name: 'Reassignment - Junior Advisor',
		// 	name: 'Junior Advisor',
		// 	// sub_name: 'Predicted Opp',
		// 	sub_name: 'Invested AUM',
		// 	key: 'afa_count',
		// 	sub_key: 'afa_value',
		// 	clickable: true,
		// 	show_analysis: false,
		// 	// show_analysis_name: 'Reassignment - Associate Financial Advisor Analysis',
		// 	// show_analysis_name: 'Reassignment - Junior Advisor Analysis',
		// 	show_analysis_name: 'Junior Advisor Analysis',
    // format_number: true,
		// 	tooltip: true,
		// 	tooltipText: [
		// 		{
		// 			// name: "The reassignment of clients to Associate Financial Advisors (AFAs) is a strategic process designed to optimize the distribution of client management responsibilities within a financial advisory firm",
		// 			name: "The reassignment of clients to Junior Advisor is a strategic process designed to optimize the distribution of client management responsibilities within a financial advisory firm",
		// 			sub_sections: [
		// 				{
		// 					name: "Objective of Client Reassignment",
		// 					// value: "This process aims to identify select clients from an advisor's book of business who may benefit from being managed by Associate Financial Advisors. The goal is to reallocate workload efficiently, enabling seasoned advisors to focus on complex client relationships and business development, while AFAs handle the active management of reassigned clients."
		// 					value: "This process aims to identify select clients from an advisor's book of business who may benefit from being managed by Junior Advisors. The goal is to reallocate workload efficiently, enabling seasoned advisors to focus on complex client relationships and business development, while Junior Advisors handle the active management of reassigned clients."
		// 				},
		// 				{
		// 					name: "Enhancing Service and Expanding Capacity",
		// 					// value: "Reassigning clients to AFAs allows senior advisors to free up a significant portion of their day-to-day activities—potentially up to 30 to 60%. This reallocation is strategic, maintaining the integrity and quality of client service while providing seasoned advisors with the opportunity to serve a larger client base or to deepen relationships with existing high-priority clients."
		// 					value: "Reassigning clients to Junior Advisors allows senior advisors to free up a significant portion of their day-to-day activities—potentially up to 30 to 60%. This reallocation is strategic, maintaining the integrity and quality of client service while providing seasoned advisors with the opportunity to serve a larger client base or to deepen relationships with existing high-priority clients."
		// 				},
		// 				{
		// 					// name: "Responsibilities of Associate Financial Advisors",
		// 					name: "Responsibilities of Junior Advisors",
		// 					// value: "Upon reassignment, Associate Financial Advisors take full responsibility for the clients transferred to their care. Their duties include but are not limited to closing deals, nurturing client relationships, and ensuring client retention. AFAs are expected to maintain the high standards set by the firm and to deliver personalized service that aligns with the firm's values and performance benchmarks.",
		// 					value: "Upon reassignment, Junior Advisors take full responsibility for the clients transferred to their care. Their duties include but are not limited to closing deals, nurturing client relationships, and ensuring client retention. Junior Advisors are expected to maintain the high standards set by the firm and to deliver personalized service that aligns with the firm's values and performance benchmarks.",
		// 				},
		// 				{
		// 					// name: "Associate Financial Advisors' Role",
		// 					name: "Junior Advisors Role",
		// 					// value: "AFAs are equipped with the necessary skills and knowledge to manage the various aspects of client relationships, including:",
		// 					value: "Junior Advisors are equipped with the necessary skills and knowledge to manage the various aspects of client relationships, including:",
		// 					sub_sections: [
		// 						{
		// 						  name: "Closing Sales",
		// 						  value: "Finalizing deals and ensuring client acquisition."
		// 						},
		// 						{
		// 							name: "Upside Opportunity Development",
		// 							value: "Identifying and acting on opportunities to enhance the client's portfolio value."
		// 						},
		// 						{
		// 							name: "Retention Management",
		// 							value: "Recognizing and mitigating retention risks to maintain a stable client base."
		// 						},
		// 					]
		// 				},
		// 				{
		// 					name: "Autonomy and Accountability",
		// 					// value: "Associate Financial Advisors operate with a degree of autonomy, bringing their professional expertise to bear on the clients' financial strategies. They are accountable for the outcomes of their client interactions and the overall satisfaction of the clients under their management."
		// 					value: "Junior Advisors operate with a degree of autonomy, bringing their professional expertise to bear on the clients' financial strategies. They are accountable for the outcomes of their client interactions and the overall satisfaction of the clients under their management."
		// 				},
		// 				{
		// 					name: "Strategic Advantages",
		// 					// value: "The reassignment of clients to AFAs is not merely a redistribution of tasks but a strategic enhancement of the firm's service delivery model. It leverages the strengths of AFAs to ensure that all clients, regardless of their investment size or complexity, receive attentive and expert advice. This approach enables the firm to scale effectively, providing a foundation for sustained growth and client service excellence."
		// 					value: "The reassignment of clients to Junior Advisors is not merely a redistribution of tasks but a strategic enhancement of the firm's service delivery model. It leverages the strengths of Junior Advisors to ensure that all clients, regardless of their investment size or complexity, receive attentive and expert advice. This approach enables the firm to scale effectively, providing a foundation for sustained growth and client service excellence."
		// 				},
		// 			]
		// 		},
		// 	],
		// 	image: "assets/afa_icon.png"

		// },
		{
			// name: 'Institutional Customers to Investment Clients',
			name: 'Bank Customers to Investment Clients',
			sub_name: 'Predicted Opp',
			key: 'new_acquisition',
			sub_key: 'new_acquisition_predicted_value',
			clickable: false,
			show_analysis: true,
			// show_analysis_name: 'Institutional Customers to Investment Clients Analysis',
			show_analysis_name: 'Bank Customers to Investment Clients Analysis',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					// name: "The Institutional Customers to Investment Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
					name: "The Bank Customers to Investment Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
					sub_sections: [
						// {
						// 	name: "Purpose of the 'Institutional Customers to Investment Clients Section",
						// 	value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Institutional Customers to Investment Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
						// },
						{
							name: "Purpose of the Bank Customers to Investment Clients Section",
							value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Bank Customers to Investment Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
						},
						{
							name: "Leveraging Existing Relationships",
							value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
						},
						{
							name: "Addressing Industry Gaps",
							value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
						},
						{
							name: "Integration with Traditional Methods",
							value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
						},
						{
							name: "Transforming Banking Clients into Investment Clients",
							value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
						},
						{
							name: "Strategic Advantage",
							// value: "The 'Institutional Customers to Investment Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
							value: "The 'Bank Customers to Investment Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
						},
					]
				},
			],
			image: "assets/inst_cross_icon.png"

		},
		{
			name: 'New Prospects',
			sub_name: 'Predicted Opp',
			key: 'new_prospect_acquisition',
			sub_key: 'new_prospect_acquisition_predicted_value',
			clickable: false,
			show_analysis: true,
			show_analysis_name: 'New Prospects Analysis',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					name: "The New Prospects section is crafted to enhance the efficiency of the lead generation and conversion process:",
					sub_sections: [
						{
							name: "Purpose of the New Prospects Section",
							value: "The core purpose of this section is to streamline the identification, engagement, and conversion of New Prospects into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
						},
						{
							name: "Leveraging Existing Relationships",
							value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
						},
						{
							name: "Addressing Industry Gaps",
							value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
						},
						{
							name: "Integration with Traditional Methods",
							value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
						},
						{
							name: "Transforming Banking Clients into Investment Clients",
							value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
						},
						{
							name: "Strategic Advantage",
							value: "The 'New Prospects section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
						},
					]
				},
			],
			image: "assets/inst_cross_icon.png"

		},
		{
			name: 'C Level Clients',
			sub_name: 'Predicted Opp',
			key: 'lv_count',
			sub_key: 'lv_aum',
			clickable: true,
			show_analysis: false,
			show_analysis_name: 'C Level Clients Analysis',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					name: "The definition for the section detailing the total c level clients within an advisor's existing book of business can be broken down into several parts for clarity:",
					sub_sections: [
						{
							name: "Overview",
							value: "This section is crafted to enlighten advisors on the breadth of untapped clients residing within their current book of business. It's a strategic tool designed to spotlight potential areas of growth and client engagement."
						},
						{
							name: "Trigger Event Business Rules",
							value: "Incorporated within this are opportunities unearthed through trigger event business rules. These rules are a curated set of indicators developed by industry experts. They signal the optimal moments and rationales for when a client might be inclined to invest in the next recommended product."
						},
						{
							name: "AI-Driven Opportunities",
							value: "Additionally, the section includes AI-driven opportunities that would typically go unnoticed without the intervention of advanced analytics. This AI model is a powerful asset, extending the advisor's insight beyond traditional methods and revealing hidden prospects for client investment."
						},
						{
							name: "Navigation",
							value: "Advisors can navigate through these opportunities by clicking on the indicated arrow. This action unfolds a detailed breakdown, categorizing opportunities by their origin—be it AI-generated or triggered by specific events. It also segments them based on their propensity to close promptly and their estimated value."
						},
						{
							name: "Ranking System",
							value: "Crucially, all opportunities are ranked to assist advisors in prioritizing their efforts. This ranking is meticulously designed to steer advisors towards opportunities that not only possess high value but also exhibit a shorter timespan for deal closure."
						},
						{
							name: "Purpose",
							value: "The ultimate goal of this section is to equip advisors with a prioritized, insightful view of their book of business, enabling them to concentrate on the most promising and lucrative opportunities for expanding their client's investment portfolio. It's a blend of expert knowledge and machine learning precision, all tailored to enhance the advisor's efficiency and success rate."
						},
					]
				},
			],
			image: "assets/upside_icon.png"
		},
	];
	advisor_opp_risks_data: any = [
		{
			name: 'Upside Opportunities',
			sub_name: 'Predicted Opp',
			key: 'upside_opp_count',
			sub_key: 'upside_opp_value',
			clickable: true,
			show_analysis: false,
			show_analysis_name: 'Upside Opportunities Analysis',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					name: "The definition for the section detailing the total upside opportunities within an advisor's existing book of business can be broken down into several parts for clarity:",
					sub_sections: [
						{
							name: "Overview",
							value: "This section is crafted to enlighten advisors on the breadth of untapped opportunities residing within their current book of business. It's a strategic tool designed to spotlight potential areas of growth and client engagement."
						},
						{
							name: "Trigger Event Business Rules",
							value: "Incorporated within this are opportunities unearthed through trigger event business rules. These rules are a curated set of indicators developed by industry experts. They signal the optimal moments and rationales for when a client might be inclined to invest in the next recommended product."
						},
						{
							name: "AI-Driven Opportunities",
							value: "Additionally, the section includes AI-driven opportunities that would typically go unnoticed without the intervention of advanced analytics. This AI model is a powerful asset, extending the advisor's insight beyond traditional methods and revealing hidden prospects for client investment."
						},
						{
							name: "Navigation",
							value: "Advisors can navigate through these opportunities by clicking on the indicated arrow. This action unfolds a detailed breakdown, categorizing opportunities by their origin—be it AI-generated or triggered by specific events. It also segments them based on their propensity to close promptly and their estimated value."
						},
						{
							name: "Ranking System",
							value: "Crucially, all opportunities are ranked to assist advisors in prioritizing their efforts. This ranking is meticulously designed to steer advisors towards opportunities that not only possess high value but also exhibit a shorter timespan for deal closure."
						},
						{
							name: "Purpose",
							value: "The ultimate goal of this section is to equip advisors with a prioritized, insightful view of their book of business, enabling them to concentrate on the most promising and lucrative opportunities for expanding their client's investment portfolio. It's a blend of expert knowledge and machine learning precision, all tailored to enhance the advisor's efficiency and success rate."
						},
					]
				},
			],
			image: "assets/upside_icon.png"
		},
		{
			name: 'Retention Opportunities',
			sub_name: 'Predicted Loss',
			key: 'retention_count',
			sub_key: 'retention_value',
			clickable: true,
			show_analysis: false,
			show_analysis_name: 'Retention Opportunities Analysis',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					name: "The client retention risk section has been designed with a multi-faceted approach to ensure that advisors have a clear and actionable understanding of potential risks within their client base:",
					sub_sections: [
						{
							name: "Section Purpose",
							value: "The purpose of this section is to equip advisors with in-depth knowledge of the risks associated with client retention in their existing portfolios. It's a critical tool aimed at preempting client turnover and fostering long-term loyalty."
						},
						{
							name: "Trigger Event Business Rules Component",
							value: "At the core of this section are the trigger event business rules. These are insights developed by seasoned industry experts that signal potential client departure scenarios. They serve as an early warning system, indicating the possible reasons a client may be contemplating ending their financial services relationship."
						},
						{
							name: "AI-Driven Risk Detection",
							value: "Beyond conventional wisdom, the section is enhanced with AI-driven insights. This sophisticated analysis surfaces risks that would be undetectable without the advanced capabilities of AI, thus offering a deeper understanding of client sentiment and potential disengagement."
						},
						{
							name: "Detailed Risk Analysis",
							value: "Advisors can access a comprehensive breakdown of these risks by interacting with the section. A simple click reveals a detailed categorization of the risks by origin and potential impact. This feature provides a clear view of which clients are at risk and the urgency of addressing their concerns, potentially opening avenues to not only retain but also to expand business with them."
						},
						{
							name: "Prioritization of Risks",
							value: "The risks are prioritized and ranked according to severity and the timeframe within which they may affect the business. This system allows advisors to anticipate and act on retention challenges well in advance, with a 2 to 3-year lead time for strategic action and relationship reinforcement."
						},
						{
							name: "Strategic Benefits",
							value: "This section is more than just a list of risks; it's a strategic asset. It offers the advisors a chance to take preemptive actions based on a comprehensive, data-driven understanding of their client base. By focusing on the highest-ranked risks, advisors can not only secure their business against potential loss but also identify opportunities for additional engagement and revenue through tailored cross-selling strategies."
						},
					]
				},
			],
			image: "assets/retention_icon.png"
		},

		{
			name: 'New Prospects',
			sub_name: 'Predicted Opp',
			key: 'new_prospect_acquisition',
			sub_key: 'new_prospect_acquisition_predicted_value',
			clickable: true,
			show_analysis: false,
			show_analysis_name: 'New Prospects Analysis',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					name: "The New Prospects section is crafted to enhance the efficiency of the lead generation and conversion process:",
					sub_sections: [
						{
							name: "Purpose of the New Prospects Section",
							value: "The core purpose of this section is to streamline the identification, engagement, and conversion of New Prospects into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
						},
						{
							name: "Leveraging Existing Relationships",
							value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
						},
						{
							name: "Addressing Industry Gaps",
							value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
						},
						{
							name: "Integration with Traditional Methods",
							value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
						},
						{
							name: "Transforming Banking Clients into Investment Clients",
							value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
						},
						{
							name: "Strategic Advantage",
							value: "The 'New Prospects section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
						},
					]
				},
			],
			image: "assets/inst_cross_icon.png"

		},
		{
			// name: 'Institutional Customers to Investment Clients',
			name: 'Bank Customers to Investment Clients',
			sub_name: 'Predicted Opp',
			key: 'new_acquisition',
			sub_key: 'new_acquisition_predicted_value',
			clickable: true,
			show_analysis: false,
			// show_analysis_name: 'Institutional Customers to Investment Clients Analysis',
			show_analysis_name: 'Bank Customers to Investment Clients Analysis',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					// name: "The Institutional Customers to Investment Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
					name: "The Bank Customers to Investment Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
					sub_sections: [
						// {
						// 	name: "Purpose of the 'Institutional Customers to Investment Clients Section",
						// 	value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Institutional Customers to Investment Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
						// },
						{
							name: "Purpose of the Bank Customers to Investment Clients Section",
							value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Bank Customers to Investment Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
						},
						{
							name: "Leveraging Existing Relationships",
							value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
						},
						{
							name: "Addressing Industry Gaps",
							value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
						},
						{
							name: "Integration with Traditional Methods",
							value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
						},
						{
							name: "Transforming Banking Clients into Investment Clients",
							value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
						},
						{
							name: "Strategic Advantage",
							// value: "The 'Institutional Customers to Investment Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
							value: "The 'Bank Customers to Investment Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
						},
					]
				},
			],
			image: "assets/inst_cross_icon.png"

		},
		{
			name: 'C Level Clients',
			sub_name: 'Predicted Opp',
			key: 'lv_count',
			sub_key: 'lv_aum',
			clickable: true,
			show_analysis: false,
			show_analysis_name: 'C Level Clients Analysis',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					name: "The definition for the section detailing the total c level clients within an advisor's existing book of business can be broken down into several parts for clarity:",
					sub_sections: [
						{
							name: "Overview",
							value: "This section is crafted to enlighten advisors on the breadth of untapped clients residing within their current book of business. It's a strategic tool designed to spotlight potential areas of growth and client engagement."
						},
						{
							name: "Trigger Event Business Rules",
							value: "Incorporated within this are opportunities unearthed through trigger event business rules. These rules are a curated set of indicators developed by industry experts. They signal the optimal moments and rationales for when a client might be inclined to invest in the next recommended product."
						},
						{
							name: "AI-Driven Opportunities",
							value: "Additionally, the section includes AI-driven opportunities that would typically go unnoticed without the intervention of advanced analytics. This AI model is a powerful asset, extending the advisor's insight beyond traditional methods and revealing hidden prospects for client investment."
						},
						{
							name: "Navigation",
							value: "Advisors can navigate through these opportunities by clicking on the indicated arrow. This action unfolds a detailed breakdown, categorizing opportunities by their origin—be it AI-generated or triggered by specific events. It also segments them based on their propensity to close promptly and their estimated value."
						},
						{
							name: "Ranking System",
							value: "Crucially, all opportunities are ranked to assist advisors in prioritizing their efforts. This ranking is meticulously designed to steer advisors towards opportunities that not only possess high value but also exhibit a shorter timespan for deal closure."
						},
						{
							name: "Purpose",
							value: "The ultimate goal of this section is to equip advisors with a prioritized, insightful view of their book of business, enabling them to concentrate on the most promising and lucrative opportunities for expanding their client's investment portfolio. It's a blend of expert knowledge and machine learning precision, all tailored to enhance the advisor's efficiency and success rate."
						},
					]
				},
			],
			image: "assets/upside_icon.png"
		},
		// {
		// 	// name: 'Reassignment - AI Advisor Assistant',
		// 	// name: 'Reassignment - MAGI',
		// 	// name: 'MAGI',
		// 	name: 'MAGI (for existing clients)',
		// 	// sub_name: 'Predicted Opp',
		// 	sub_name: 'Invested AUM',
		// 	key: 'ai_assistant_count',
		// 	sub_key: 'ai_assistant_value',
		// 	clickable: true,
		// 	show_analysis: false,
		// 	// show_analysis_name: 'Reassignment - AI Advisor Assistant Analysis',
		// 	// show_analysis_name: 'Reassignment - MAGI Analysis',
		// 	show_analysis_name: 'MAGI Analysis',
		// 	format_number: true,
		// 	tooltip: true,
		// 	tooltipText: [
		// 		{
		// 			name: "This section is designed to enhance the efficiency and effectiveness of advisors by leveraging AI technology:",
		// 			sub_sections: [
		// 				{
		// 					name: "Section Purpose",
		// 					// value: "This section is created to identify clients within an advisor's book of business who are suitable candidates for reassignment to the AI Advisor Assistant. The objective is to streamline the advisor's workflow, significantly reducing daily tasks by 30 to 60%."
		// 					value: "This section is created to identify clients within an advisor's book of business who are suitable candidates for reassignment to the MAGI. The objective is to streamline the advisor's workflow, significantly reducing daily tasks by 30 to 60%."
		// 				},
		// 				{
		// 					name: "Benefits of Reassignment",
		// 					// value: "By reallocating certain clients to the AI Advisor Assistant, advisors can optimize their schedules, allowing them to expand their clientele and elevate the quality of service offered to existing clients. This transition is designed to retain the full spectrum of service benefits while simultaneously granting advisors additional bandwidth for client engagement and business development."
		// 					value: "By reallocating certain clients to the MAGI, advisors can optimize their schedules, allowing them to expand their clientele and elevate the quality of service offered to existing clients. This transition is designed to retain the full spectrum of service benefits while simultaneously granting advisors additional bandwidth for client engagement and business development."
		// 				},
		// 				{
		// 					// name: "AI Advisor Assistant Capabilities",
		// 					name: "MAGI Capabilities",
		// 					// value: "The AI Advisor Assistant is an advanced system, an amalgam of various AI models, each specializing in distinct areas of client management. These models include:",
		// 					value: "The MAGI is an advanced system, an amalgam of various AI models, each specializing in distinct areas of client management. These models include:",
		// 					sub_sections: [
		// 						{
		// 						name: "Best Client Interaction Strategy",
		// 						value: "Tailored communication tactics to engage clients effectively."
		// 						},
		// 						{
		// 							name: "Upside Opportunities Identification",
		// 							value: "Recognition of potential areas for financial growth within the client's portfolio."
		// 						},
		// 						{
		// 							name: "Retention Risk Analysis",
		// 							value: "Detection of signals that may indicate a client is at risk of ending their services."
		// 						},
		// 					]
		// 				},
		// 				{
		// 					name: "Training and Performance",
		// 					value: "This feature has undergone extensive training, modeling its approach on the patterns and strategies of high-performing advisors. It analyzes how successful advisors respond to leads and manage retention risks, applying these best practices autonomously to manage routine tasks and client interactions."
		// 				},
		// 				{
		// 					name: "Automation and Efficiency",
		// 					// value: "The AI Advisor Assistant is a testament to the power of automation, embodying the capability to take over a substantial portion of the advisor's operational duties. This allows for a more focused and strategic allocation of the advisor's time and expertise, ensuring that clients receive top-tier advisory services while the advisor's practice becomes more scalable and efficient."
		// 					value: "The MAGI is a testament to the power of automation, embodying the capability to take over a substantial portion of the advisor's operational duties. This allows for a more focused and strategic allocation of the advisor's time and expertise, ensuring that clients receive top-tier advisory services while the advisor's practice becomes more scalable and efficient."
		// 				},
		// 			]
		// 		},
		// 	],
		// 	image: "assets/ai_assistant_icon.png"

		// },
		{
			// name: 'Reassignment - Associate Financial Advisor',
			// name: 'Reassignment - Junior Advisor',
			name: 'Junior Advisor',
			// sub_name: 'Predicted Opp',
			sub_name: 'Invested AUM',
			key: 'afa_count',
			sub_key: 'afa_value',
			clickable: true,
			show_analysis: false,
			// show_analysis_name: 'Reassignment - Associate Financial Advisor Analysis',
			// show_analysis_name: 'Reassignment - Junior Advisor Analysis',
			show_analysis_name: 'Junior Advisor Analysis',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					// name: "The reassignment of clients to Associate Financial Advisors (AFAs) is a strategic process designed to optimize the distribution of client management responsibilities within a financial advisory firm",
					name: "The reassignment of clients to Junior Advisor is a strategic process designed to optimize the distribution of client management responsibilities within a financial advisory firm",
					sub_sections: [
						{
							name: "Objective of Client Reassignment",
							// value: "This process aims to identify select clients from an advisor's book of business who may benefit from being managed by Associate Financial Advisors. The goal is to reallocate workload efficiently, enabling seasoned advisors to focus on complex client relationships and business development, while AFAs handle the active management of reassigned clients."
							value: "This process aims to identify select clients from an advisor's book of business who may benefit from being managed by Junior Advisors. The goal is to reallocate workload efficiently, enabling seasoned advisors to focus on complex client relationships and business development, while Junior Advisors handle the active management of reassigned clients."
						},
						{
							name: "Enhancing Service and Expanding Capacity",
							// value: "Reassigning clients to AFAs allows senior advisors to free up a significant portion of their day-to-day activities—potentially up to 30 to 60%. This reallocation is strategic, maintaining the integrity and quality of client service while providing seasoned advisors with the opportunity to serve a larger client base or to deepen relationships with existing high-priority clients."
							value: "Reassigning clients to Junior Advisors allows senior advisors to free up a significant portion of their day-to-day activities—potentially up to 30 to 60%. This reallocation is strategic, maintaining the integrity and quality of client service while providing seasoned advisors with the opportunity to serve a larger client base or to deepen relationships with existing high-priority clients."
						},
						{
							// name: "Responsibilities of Associate Financial Advisors",
							name: "Responsibilities of Junior Advisors",
							// value: "Upon reassignment, Associate Financial Advisors take full responsibility for the clients transferred to their care. Their duties include but are not limited to closing deals, nurturing client relationships, and ensuring client retention. AFAs are expected to maintain the high standards set by the firm and to deliver personalized service that aligns with the firm's values and performance benchmarks.",
							value: "Upon reassignment, Junior Advisors take full responsibility for the clients transferred to their care. Their duties include but are not limited to closing deals, nurturing client relationships, and ensuring client retention. Junior Advisors are expected to maintain the high standards set by the firm and to deliver personalized service that aligns with the firm's values and performance benchmarks.",
						},
						{
							// name: "Associate Financial Advisors' Role",
							name: "Junior Advisors Role",
							// value: "AFAs are equipped with the necessary skills and knowledge to manage the various aspects of client relationships, including:",
							value: "Junior Advisors are equipped with the necessary skills and knowledge to manage the various aspects of client relationships, including:",
							sub_sections: [
								{
								  name: "Closing Sales",
								  value: "Finalizing deals and ensuring client acquisition."
								},
								{
									name: "Upside Opportunity Development",
									value: "Identifying and acting on opportunities to enhance the client's portfolio value."
								},
								{
									name: "Retention Management",
									value: "Recognizing and mitigating retention risks to maintain a stable client base."
								},
							]
						},
						{
							name: "Autonomy and Accountability",
							// value: "Associate Financial Advisors operate with a degree of autonomy, bringing their professional expertise to bear on the clients' financial strategies. They are accountable for the outcomes of their client interactions and the overall satisfaction of the clients under their management."
							value: "Junior Advisors operate with a degree of autonomy, bringing their professional expertise to bear on the clients' financial strategies. They are accountable for the outcomes of their client interactions and the overall satisfaction of the clients under their management."
						},
						{
							name: "Strategic Advantages",
							// value: "The reassignment of clients to AFAs is not merely a redistribution of tasks but a strategic enhancement of the firm's service delivery model. It leverages the strengths of AFAs to ensure that all clients, regardless of their investment size or complexity, receive attentive and expert advice. This approach enables the firm to scale effectively, providing a foundation for sustained growth and client service excellence."
							value: "The reassignment of clients to Junior Advisors is not merely a redistribution of tasks but a strategic enhancement of the firm's service delivery model. It leverages the strengths of Junior Advisors to ensure that all clients, regardless of their investment size or complexity, receive attentive and expert advice. This approach enables the firm to scale effectively, providing a foundation for sustained growth and client service excellence."
						},
					]
				},
			],
			image: "assets/afa_icon.png"

		},

  	];
	advisor_opp_risks_data1: any = [
		{
			name: 'New Prospects',
			sub_name: 'Predicted Opp',
			key: 'new_prospect_acquisition',
			sub_key: 'new_prospect_acquisition_predicted_value',
			clickable: true,
			show_analysis: false,
			show_analysis_name: 'New Prospects Analysis',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					name: "The New Prospects section is crafted to enhance the efficiency of the lead generation and conversion process:",
					sub_sections: [
						{
							name: "Purpose of the New Prospects Section",
							value: "The core purpose of this section is to streamline the identification, engagement, and conversion of New Prospects into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
						},
						{
							name: "Leveraging Existing Relationships",
							value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
						},
						{
							name: "Addressing Industry Gaps",
							value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
						},
						{
							name: "Integration with Traditional Methods",
							value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
						},
						{
							name: "Transforming Banking Clients into Investment Clients",
							value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
						},
						{
							name: "Strategic Advantage",
							value: "The 'New Prospects section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
						},
					]
				},
			],
			image: "assets/inst_cross_icon.png"

		},
		{
			name: 'Upside Opportunities',
			sub_name: 'Predicted Opp',
			key: 'upside_opp_count',
			sub_key: 'upside_opp_value',
			clickable: false,
			show_analysis: false,
			show_analysis_name: 'Upside Opportunities Analysis',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					name: "The definition for the section detailing the total upside opportunities within an advisor's existing book of business can be broken down into several parts for clarity:",
					sub_sections: [
						{
							name: "Overview",
							value: "This section is crafted to enlighten advisors on the breadth of untapped opportunities residing within their current book of business. It's a strategic tool designed to spotlight potential areas of growth and client engagement."
						},
						{
							name: "Trigger Event Business Rules",
							value: "Incorporated within this are opportunities unearthed through trigger event business rules. These rules are a curated set of indicators developed by industry experts. They signal the optimal moments and rationales for when a client might be inclined to invest in the next recommended product."
						},
						{
							name: "AI-Driven Opportunities",
							value: "Additionally, the section includes AI-driven opportunities that would typically go unnoticed without the intervention of advanced analytics. This AI model is a powerful asset, extending the advisor's insight beyond traditional methods and revealing hidden prospects for client investment."
						},
						{
							name: "Navigation",
							value: "Advisors can navigate through these opportunities by clicking on the indicated arrow. This action unfolds a detailed breakdown, categorizing opportunities by their origin—be it AI-generated or triggered by specific events. It also segments them based on their propensity to close promptly and their estimated value."
						},
						{
							name: "Ranking System",
							value: "Crucially, all opportunities are ranked to assist advisors in prioritizing their efforts. This ranking is meticulously designed to steer advisors towards opportunities that not only possess high value but also exhibit a shorter timespan for deal closure."
						},
						{
							name: "Purpose",
							value: "The ultimate goal of this section is to equip advisors with a prioritized, insightful view of their book of business, enabling them to concentrate on the most promising and lucrative opportunities for expanding their client's investment portfolio. It's a blend of expert knowledge and machine learning precision, all tailored to enhance the advisor's efficiency and success rate."
						},
					]
				},
			],
			image: "assets/upside_icon.png"
		},
		{
			name: 'Retention Opportunities',
			sub_name: 'Predicted Loss',
			key: 'retention_count',
			sub_key: 'retention_value',
			clickable: false,
			show_analysis: false,
			show_analysis_name: 'Retention Opportunities Analysis',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					name: "The client retention risk section has been designed with a multi-faceted approach to ensure that advisors have a clear and actionable understanding of potential risks within their client base:",
					sub_sections: [
						{
							name: "Section Purpose",
							value: "The purpose of this section is to equip advisors with in-depth knowledge of the risks associated with client retention in their existing portfolios. It's a critical tool aimed at preempting client turnover and fostering long-term loyalty."
						},
						{
							name: "Trigger Event Business Rules Component",
							value: "At the core of this section are the trigger event business rules. These are insights developed by seasoned industry experts that signal potential client departure scenarios. They serve as an early warning system, indicating the possible reasons a client may be contemplating ending their financial services relationship."
						},
						{
							name: "AI-Driven Risk Detection",
							value: "Beyond conventional wisdom, the section is enhanced with AI-driven insights. This sophisticated analysis surfaces risks that would be undetectable without the advanced capabilities of AI, thus offering a deeper understanding of client sentiment and potential disengagement."
						},
						{
							name: "Detailed Risk Analysis",
							value: "Advisors can access a comprehensive breakdown of these risks by interacting with the section. A simple click reveals a detailed categorization of the risks by origin and potential impact. This feature provides a clear view of which clients are at risk and the urgency of addressing their concerns, potentially opening avenues to not only retain but also to expand business with them."
						},
						{
							name: "Prioritization of Risks",
							value: "The risks are prioritized and ranked according to severity and the timeframe within which they may affect the business. This system allows advisors to anticipate and act on retention challenges well in advance, with a 2 to 3-year lead time for strategic action and relationship reinforcement."
						},
						{
							name: "Strategic Benefits",
							value: "This section is more than just a list of risks; it's a strategic asset. It offers the advisors a chance to take preemptive actions based on a comprehensive, data-driven understanding of their client base. By focusing on the highest-ranked risks, advisors can not only secure their business against potential loss but also identify opportunities for additional engagement and revenue through tailored cross-selling strategies."
						},
					]
				},
			],
			image: "assets/retention_icon.png"
		},

		
		// {
		// 	// name: 'Institutional Customers to Investment Clients',
		// 	name: 'Bank Customers to Investment Clients',
		// 	sub_name: 'Predicted Opp',
		// 	key: 'new_acquisition',
		// 	sub_key: 'new_acquisition_predicted_value',
		// 	clickable: true,
		// 	show_analysis: false,
		// 	// show_analysis_name: 'Institutional Customers to Investment Clients Analysis',
		// 	show_analysis_name: 'Bank Customers to Investment Clients Analysis',
		// 	format_number: true,
		// 	tooltip: true,
		// 	tooltipText: [
		// 		{
		// 			// name: "The Institutional Customers to Investment Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
		// 			name: "The Bank Customers to Investment Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
		// 			sub_sections: [
		// 				// {
		// 				// 	name: "Purpose of the 'Institutional Customers to Investment Clients Section",
		// 				// 	value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Institutional Customers to Investment Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
		// 				// },
		// 				{
		// 					name: "Purpose of the Bank Customers to Investment Clients Section",
		// 					value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Bank Customers to Investment Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
		// 				},
		// 				{
		// 					name: "Leveraging Existing Relationships",
		// 					value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
		// 				},
		// 				{
		// 					name: "Addressing Industry Gaps",
		// 					value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
		// 				},
		// 				{
		// 					name: "Integration with Traditional Methods",
		// 					value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
		// 				},
		// 				{
		// 					name: "Transforming Banking Clients into Investment Clients",
		// 					value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
		// 				},
		// 				{
		// 					name: "Strategic Advantage",
		// 					// value: "The 'Institutional Customers to Investment Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
		// 					value: "The 'Bank Customers to Investment Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
		// 				},
		// 			]
		// 		},
		// 	],
		// 	image: "assets/inst_cross_icon.png"

		// },
		{
			name: 'C Level Clients',
			sub_name: 'Predicted Opp',
			key: 'lv_count',
			sub_key: 'lv_aum',
			clickable: false,
			show_analysis: false,
			show_analysis_name: 'C Level Clients Analysis',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					name: "The definition for the section detailing the total c level clients within an advisor's existing book of business can be broken down into several parts for clarity:",
					sub_sections: [
						{
							name: "Overview",
							value: "This section is crafted to enlighten advisors on the breadth of untapped clients residing within their current book of business. It's a strategic tool designed to spotlight potential areas of growth and client engagement."
						},
						{
							name: "Trigger Event Business Rules",
							value: "Incorporated within this are opportunities unearthed through trigger event business rules. These rules are a curated set of indicators developed by industry experts. They signal the optimal moments and rationales for when a client might be inclined to invest in the next recommended product."
						},
						{
							name: "AI-Driven Opportunities",
							value: "Additionally, the section includes AI-driven opportunities that would typically go unnoticed without the intervention of advanced analytics. This AI model is a powerful asset, extending the advisor's insight beyond traditional methods and revealing hidden prospects for client investment."
						},
						{
							name: "Navigation",
							value: "Advisors can navigate through these opportunities by clicking on the indicated arrow. This action unfolds a detailed breakdown, categorizing opportunities by their origin—be it AI-generated or triggered by specific events. It also segments them based on their propensity to close promptly and their estimated value."
						},
						{
							name: "Ranking System",
							value: "Crucially, all opportunities are ranked to assist advisors in prioritizing their efforts. This ranking is meticulously designed to steer advisors towards opportunities that not only possess high value but also exhibit a shorter timespan for deal closure."
						},
						{
							name: "Purpose",
							value: "The ultimate goal of this section is to equip advisors with a prioritized, insightful view of their book of business, enabling them to concentrate on the most promising and lucrative opportunities for expanding their client's investment portfolio. It's a blend of expert knowledge and machine learning precision, all tailored to enhance the advisor's efficiency and success rate."
						},
					]
				},
			],
			image: "assets/upside_icon.png"
		},
		// {
		// 	// name: 'Reassignment - AI Advisor Assistant',
		// 	// name: 'Reassignment - MAGI',
		// 	// name: 'MAGI',
		// 	name: 'MAGI (for existing clients)',
		// 	// sub_name: 'Predicted Opp',
		// 	sub_name: 'Invested AUM',
		// 	key: 'ai_assistant_count',
		// 	sub_key: 'ai_assistant_value',
		// 	clickable: true,
		// 	show_analysis: false,
		// 	// show_analysis_name: 'Reassignment - AI Advisor Assistant Analysis',
		// 	// show_analysis_name: 'Reassignment - MAGI Analysis',
		// 	show_analysis_name: 'MAGI Analysis',
		// 	format_number: true,
		// 	tooltip: true,
		// 	tooltipText: [
		// 		{
		// 			name: "This section is designed to enhance the efficiency and effectiveness of advisors by leveraging AI technology:",
		// 			sub_sections: [
		// 				{
		// 					name: "Section Purpose",
		// 					// value: "This section is created to identify clients within an advisor's book of business who are suitable candidates for reassignment to the AI Advisor Assistant. The objective is to streamline the advisor's workflow, significantly reducing daily tasks by 30 to 60%."
		// 					value: "This section is created to identify clients within an advisor's book of business who are suitable candidates for reassignment to the MAGI. The objective is to streamline the advisor's workflow, significantly reducing daily tasks by 30 to 60%."
		// 				},
		// 				{
		// 					name: "Benefits of Reassignment",
		// 					// value: "By reallocating certain clients to the AI Advisor Assistant, advisors can optimize their schedules, allowing them to expand their clientele and elevate the quality of service offered to existing clients. This transition is designed to retain the full spectrum of service benefits while simultaneously granting advisors additional bandwidth for client engagement and business development."
		// 					value: "By reallocating certain clients to the MAGI, advisors can optimize their schedules, allowing them to expand their clientele and elevate the quality of service offered to existing clients. This transition is designed to retain the full spectrum of service benefits while simultaneously granting advisors additional bandwidth for client engagement and business development."
		// 				},
		// 				{
		// 					// name: "AI Advisor Assistant Capabilities",
		// 					name: "MAGI Capabilities",
		// 					// value: "The AI Advisor Assistant is an advanced system, an amalgam of various AI models, each specializing in distinct areas of client management. These models include:",
		// 					value: "The MAGI is an advanced system, an amalgam of various AI models, each specializing in distinct areas of client management. These models include:",
		// 					sub_sections: [
		// 						{
		// 						name: "Best Client Interaction Strategy",
		// 						value: "Tailored communication tactics to engage clients effectively."
		// 						},
		// 						{
		// 							name: "Upside Opportunities Identification",
		// 							value: "Recognition of potential areas for financial growth within the client's portfolio."
		// 						},
		// 						{
		// 							name: "Retention Risk Analysis",
		// 							value: "Detection of signals that may indicate a client is at risk of ending their services."
		// 						},
		// 					]
		// 				},
		// 				{
		// 					name: "Training and Performance",
		// 					value: "This feature has undergone extensive training, modeling its approach on the patterns and strategies of high-performing advisors. It analyzes how successful advisors respond to leads and manage retention risks, applying these best practices autonomously to manage routine tasks and client interactions."
		// 				},
		// 				{
		// 					name: "Automation and Efficiency",
		// 					// value: "The AI Advisor Assistant is a testament to the power of automation, embodying the capability to take over a substantial portion of the advisor's operational duties. This allows for a more focused and strategic allocation of the advisor's time and expertise, ensuring that clients receive top-tier advisory services while the advisor's practice becomes more scalable and efficient."
		// 					value: "The MAGI is a testament to the power of automation, embodying the capability to take over a substantial portion of the advisor's operational duties. This allows for a more focused and strategic allocation of the advisor's time and expertise, ensuring that clients receive top-tier advisory services while the advisor's practice becomes more scalable and efficient."
		// 				},
		// 			]
		// 		},
		// 	],
		// 	image: "assets/ai_assistant_icon.png"

		// },
		// {
		// 	// name: 'Reassignment - Associate Financial Advisor',
		// 	// name: 'Reassignment - Junior Advisor',
		// 	name: 'Junior Advisor',
		// 	// sub_name: 'Predicted Opp',
		// 	sub_name: 'Invested AUM',
		// 	key: 'afa_count',
		// 	sub_key: 'afa_value',
		// 	clickable: true,
		// 	show_analysis: false,
		// 	// show_analysis_name: 'Reassignment - Associate Financial Advisor Analysis',
		// 	// show_analysis_name: 'Reassignment - Junior Advisor Analysis',
		// 	show_analysis_name: 'Junior Advisor Analysis',
		// 	format_number: true,
		// 	tooltip: true,
		// 	tooltipText: [
		// 		{
		// 			// name: "The reassignment of clients to Associate Financial Advisors (AFAs) is a strategic process designed to optimize the distribution of client management responsibilities within a financial advisory firm",
		// 			name: "The reassignment of clients to Junior Advisor is a strategic process designed to optimize the distribution of client management responsibilities within a financial advisory firm",
		// 			sub_sections: [
		// 				{
		// 					name: "Objective of Client Reassignment",
		// 					// value: "This process aims to identify select clients from an advisor's book of business who may benefit from being managed by Associate Financial Advisors. The goal is to reallocate workload efficiently, enabling seasoned advisors to focus on complex client relationships and business development, while AFAs handle the active management of reassigned clients."
		// 					value: "This process aims to identify select clients from an advisor's book of business who may benefit from being managed by Junior Advisors. The goal is to reallocate workload efficiently, enabling seasoned advisors to focus on complex client relationships and business development, while Junior Advisors handle the active management of reassigned clients."
		// 				},
		// 				{
		// 					name: "Enhancing Service and Expanding Capacity",
		// 					// value: "Reassigning clients to AFAs allows senior advisors to free up a significant portion of their day-to-day activities—potentially up to 30 to 60%. This reallocation is strategic, maintaining the integrity and quality of client service while providing seasoned advisors with the opportunity to serve a larger client base or to deepen relationships with existing high-priority clients."
		// 					value: "Reassigning clients to Junior Advisors allows senior advisors to free up a significant portion of their day-to-day activities—potentially up to 30 to 60%. This reallocation is strategic, maintaining the integrity and quality of client service while providing seasoned advisors with the opportunity to serve a larger client base or to deepen relationships with existing high-priority clients."
		// 				},
		// 				{
		// 					// name: "Responsibilities of Associate Financial Advisors",
		// 					name: "Responsibilities of Junior Advisors",
		// 					// value: "Upon reassignment, Associate Financial Advisors take full responsibility for the clients transferred to their care. Their duties include but are not limited to closing deals, nurturing client relationships, and ensuring client retention. AFAs are expected to maintain the high standards set by the firm and to deliver personalized service that aligns with the firm's values and performance benchmarks.",
		// 					value: "Upon reassignment, Junior Advisors take full responsibility for the clients transferred to their care. Their duties include but are not limited to closing deals, nurturing client relationships, and ensuring client retention. Junior Advisors are expected to maintain the high standards set by the firm and to deliver personalized service that aligns with the firm's values and performance benchmarks.",
		// 				},
		// 				{
		// 					// name: "Associate Financial Advisors' Role",
		// 					name: "Junior Advisors Role",
		// 					// value: "AFAs are equipped with the necessary skills and knowledge to manage the various aspects of client relationships, including:",
		// 					value: "Junior Advisors are equipped with the necessary skills and knowledge to manage the various aspects of client relationships, including:",
		// 					sub_sections: [
		// 						{
		// 						  name: "Closing Sales",
		// 						  value: "Finalizing deals and ensuring client acquisition."
		// 						},
		// 						{
		// 							name: "Upside Opportunity Development",
		// 							value: "Identifying and acting on opportunities to enhance the client's portfolio value."
		// 						},
		// 						{
		// 							name: "Retention Management",
		// 							value: "Recognizing and mitigating retention risks to maintain a stable client base."
		// 						},
		// 					]
		// 				},
		// 				{
		// 					name: "Autonomy and Accountability",
		// 					// value: "Associate Financial Advisors operate with a degree of autonomy, bringing their professional expertise to bear on the clients' financial strategies. They are accountable for the outcomes of their client interactions and the overall satisfaction of the clients under their management."
		// 					value: "Junior Advisors operate with a degree of autonomy, bringing their professional expertise to bear on the clients' financial strategies. They are accountable for the outcomes of their client interactions and the overall satisfaction of the clients under their management."
		// 				},
		// 				{
		// 					name: "Strategic Advantages",
		// 					// value: "The reassignment of clients to AFAs is not merely a redistribution of tasks but a strategic enhancement of the firm's service delivery model. It leverages the strengths of AFAs to ensure that all clients, regardless of their investment size or complexity, receive attentive and expert advice. This approach enables the firm to scale effectively, providing a foundation for sustained growth and client service excellence."
		// 					value: "The reassignment of clients to Junior Advisors is not merely a redistribution of tasks but a strategic enhancement of the firm's service delivery model. It leverages the strengths of Junior Advisors to ensure that all clients, regardless of their investment size or complexity, receive attentive and expert advice. This approach enables the firm to scale effectively, providing a foundation for sustained growth and client service excellence."
		// 				},
		// 			]
		// 		},
		// 	],
		// 	image: "assets/afa_icon.png"

		// },

  	];
  	afa_opp_risks_data: any = [
		{
			name: 'Upside Opportunities',
			sub_name: 'Predicted Opp',
			key: 'upside_opp_count',
			sub_key: 'upside_opp_value',
			clickable: true,
			show_analysis: false,
			show_analysis_name: 'Upside Opportunities Analysis',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					name: "The definition for the section detailing the total upside opportunities within an advisor's existing book of business can be broken down into several parts for clarity:",
					sub_sections: [
						{
							name: "Overview",
							value: "This section is crafted to enlighten advisors on the breadth of untapped opportunities residing within their current book of business. It's a strategic tool designed to spotlight potential areas of growth and client engagement."
						},
						{
							name: "Trigger Event Business Rules",
							value: "Incorporated within this are opportunities unearthed through trigger event business rules. These rules are a curated set of indicators developed by industry experts. They signal the optimal moments and rationales for when a client might be inclined to invest in the next recommended product."
						},
						{
							name: "AI-Driven Opportunities",
							value: "Additionally, the section includes AI-driven opportunities that would typically go unnoticed without the intervention of advanced analytics. This AI model is a powerful asset, extending the advisor's insight beyond traditional methods and revealing hidden prospects for client investment."
						},
						{
							name: "Navigation",
							value: "Advisors can navigate through these opportunities by clicking on the indicated arrow. This action unfolds a detailed breakdown, categorizing opportunities by their origin—be it AI-generated or triggered by specific events. It also segments them based on their propensity to close promptly and their estimated value."
						},
						{
							name: "Ranking System",
							value: "Crucially, all opportunities are ranked to assist advisors in prioritizing their efforts. This ranking is meticulously designed to steer advisors towards opportunities that not only possess high value but also exhibit a shorter timespan for deal closure."
						},
						{
							name: "Purpose",
							value: "The ultimate goal of this section is to equip advisors with a prioritized, insightful view of their book of business, enabling them to concentrate on the most promising and lucrative opportunities for expanding their client's investment portfolio. It's a blend of expert knowledge and machine learning precision, all tailored to enhance the advisor's efficiency and success rate."
						},
					]
				},
			],
			image: "assets/upside_icon.png"
		},
		{
			name: 'Retention Opportunities',
			sub_name: 'Predicted Loss',
			key: 'retention_count',
			sub_key: 'retention_value',
			clickable: true,
			show_analysis: false,
			show_analysis_name: 'Retention Opportunities Analysis',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					name: "The client retention risk section has been designed with a multi-faceted approach to ensure that advisors have a clear and actionable understanding of potential risks within their client base:",
					sub_sections: [
						{
							name: "Section Purpose",
							value: "The purpose of this section is to equip advisors with in-depth knowledge of the risks associated with client retention in their existing portfolios. It's a critical tool aimed at preempting client turnover and fostering long-term loyalty."
						},
						{
							name: "Trigger Event Business Rules Component",
							value: "At the core of this section are the trigger event business rules. These are insights developed by seasoned industry experts that signal potential client departure scenarios. They serve as an early warning system, indicating the possible reasons a client may be contemplating ending their financial services relationship."
						},
						{
							name: "AI-Driven Risk Detection",
							value: "Beyond conventional wisdom, the section is enhanced with AI-driven insights. This sophisticated analysis surfaces risks that would be undetectable without the advanced capabilities of AI, thus offering a deeper understanding of client sentiment and potential disengagement."
						},
						{
							name: "Detailed Risk Analysis",
							value: "Advisors can access a comprehensive breakdown of these risks by interacting with the section. A simple click reveals a detailed categorization of the risks by origin and potential impact. This feature provides a clear view of which clients are at risk and the urgency of addressing their concerns, potentially opening avenues to not only retain but also to expand business with them."
						},
						{
							name: "Prioritization of Risks",
							value: "The risks are prioritized and ranked according to severity and the timeframe within which they may affect the business. This system allows advisors to anticipate and act on retention challenges well in advance, with a 2 to 3-year lead time for strategic action and relationship reinforcement."
						},
						{
							name: "Strategic Benefits",
							value: "This section is more than just a list of risks; it's a strategic asset. It offers the advisors a chance to take preemptive actions based on a comprehensive, data-driven understanding of their client base. By focusing on the highest-ranked risks, advisors can not only secure their business against potential loss but also identify opportunities for additional engagement and revenue through tailored cross-selling strategies."
						},
					]
				},
			],
			image: "assets/retention_icon.png"
		},
		{
			// name: 'Reassignment - AI Advisor Assistant',
			// name: 'Reassignment - MAGI',
			// name: 'MAGI',
			name: 'MAGI (for existing clients)',
			// sub_name: 'Predicted Opp',
			sub_name: 'Invested AUM',
			key: 'ai_assistant_count',
			sub_key: 'ai_assistant_value',
			clickable: true,
			show_analysis: false,
			// show_analysis_name: 'Reassignment - AI Advisor Assistant Analysis',
			// show_analysis_name: 'Reassignment - MAGI Analysis',
			show_analysis_name: 'MAGI Analysis',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					name: "This section is designed to enhance the efficiency and effectiveness of advisors by leveraging AI technology:",
					sub_sections: [
						{
							name: "Section Purpose",
							// value: "This section is created to identify clients within an advisor's book of business who are suitable candidates for reassignment to the AI Advisor Assistant. The objective is to streamline the advisor's workflow, significantly reducing daily tasks by 30 to 60%."
							value: "This section is created to identify clients within an advisor's book of business who are suitable candidates for reassignment to the MAGI. The objective is to streamline the advisor's workflow, significantly reducing daily tasks by 30 to 60%."
						},
						{
							name: "Benefits of Reassignment",
							// value: "By reallocating certain clients to the AI Advisor Assistant, advisors can optimize their schedules, allowing them to expand their clientele and elevate the quality of service offered to existing clients. This transition is designed to retain the full spectrum of service benefits while simultaneously granting advisors additional bandwidth for client engagement and business development."
							value: "By reallocating certain clients to the MAGI, advisors can optimize their schedules, allowing them to expand their clientele and elevate the quality of service offered to existing clients. This transition is designed to retain the full spectrum of service benefits while simultaneously granting advisors additional bandwidth for client engagement and business development."
						},
						{
							// name: "AI Advisor Assistant Capabilities",
							name: "MAGI Capabilities",
							// value: "The AI Advisor Assistant is an advanced system, an amalgam of various AI models, each specializing in distinct areas of client management. These models include:",
							value: "The MAGI is an advanced system, an amalgam of various AI models, each specializing in distinct areas of client management. These models include:",
							sub_sections: [
								{
								name: "Best Client Interaction Strategy",
								value: "Tailored communication tactics to engage clients effectively."
								},
								{
									name: "Upside Opportunities Identification",
									value: "Recognition of potential areas for financial growth within the client's portfolio."
								},
								{
									name: "Retention Risk Analysis",
									value: "Detection of signals that may indicate a client is at risk of ending their services."
								},
							]
						},
						{
							name: "Training and Performance",
							value: "This feature has undergone extensive training, modeling its approach on the patterns and strategies of high-performing advisors. It analyzes how successful advisors respond to leads and manage retention risks, applying these best practices autonomously to manage routine tasks and client interactions."
						},
						{
							name: "Automation and Efficiency",
							// value: "The AI Advisor Assistant is a testament to the power of automation, embodying the capability to take over a substantial portion of the advisor's operational duties. This allows for a more focused and strategic allocation of the advisor's time and expertise, ensuring that clients receive top-tier advisory services while the advisor's practice becomes more scalable and efficient."
							value: "The MAGI is a testament to the power of automation, embodying the capability to take over a substantial portion of the advisor's operational duties. This allows for a more focused and strategic allocation of the advisor's time and expertise, ensuring that clients receive top-tier advisory services while the advisor's practice becomes more scalable and efficient."
						},
					]
				},
			],
			image: "assets/ai_assistant_icon.png"

		},
		{
			// name: 'Institutional Customers to Investment Clients',
			name: 'Bank Customers to Investment Clients',
			sub_name: 'Predicted Opp',
			key: 'new_acquisition',
			sub_key: 'new_acquisition_predicted_value',
			clickable: true,
			show_analysis: false,
			// show_analysis_name: 'Institutional Customers to Investment Clients Analysis',
			show_analysis_name: 'Bank Customers to Investment Clients Analysis',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					// name: "The Institutional Customers to Investment Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
					name: "The Bank Customers to Investment Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
					sub_sections: [
						// {
						// 	name: "Purpose of the 'Institutional Customers to Investment Clients Section",
						// 	value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Institutional Customers to Investment Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
						// },
						{
							name: "Purpose of the Bank Customers to Investment Clients Section",
							value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Bank Customers to Investment Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
						},
						{
							name: "Leveraging Existing Relationships",
							value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
						},
						{
							name: "Addressing Industry Gaps",
							value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
						},
						{
							name: "Integration with Traditional Methods",
							value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
						},
						{
							name: "Transforming Banking Clients into Investment Clients",
							value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
						},
						{
							name: "Strategic Advantage",
							value: "The 'Institutional Customers to Investment Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
						},
					]
				},
			],
			image: "assets/inst_cross_icon.png"

		},
		{
			name: 'New Prospects',
			sub_name: 'Predicted Opp',
			key: 'new_prospect_acquisition',
			sub_key: 'new_prospect_acquisition_predicted_value',
			clickable: true,
			show_analysis: false,
			show_analysis_name: 'New Prospects Analysis',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					name: "The New Prospects section is crafted to enhance the efficiency of the lead generation and conversion process:",
					sub_sections: [
						{
							name: "Purpose of the New Prospects Section",
							value: "The core purpose of this section is to streamline the identification, engagement, and conversion of New Prospects into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
						},
						{
							name: "Leveraging Existing Relationships",
							value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
						},
						{
							name: "Addressing Industry Gaps",
							value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
						},
						{
							name: "Integration with Traditional Methods",
							value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
						},
						{
							name: "Transforming Banking Clients into Investment Clients",
							value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
						},
						{
							name: "Strategic Advantage",
							value: "The 'New Prospects section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
						},
					]
				},
			],
			image: "assets/inst_cross_icon.png"

		},
	];
	relationship_manager_opp_risks_data: any = [
		{
			name: 'Upside Opportunities',
			sub_name: 'Predicted Opp',
			key: 'upside_opp_count',
			sub_key: 'upside_opp_value',
			clickable: true,
			show_analysis: false,
			show_analysis_name: 'Upside Opportunities Analysis',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					name: "The definition for the section detailing the total upside opportunities within an advisor's existing book of business can be broken down into several parts for clarity:",
					sub_sections: [
						{
							name: "Overview",
							value: "This section is crafted to enlighten advisors on the breadth of untapped opportunities residing within their current book of business. It's a strategic tool designed to spotlight potential areas of growth and client engagement."
						},
						{
							name: "Trigger Event Business Rules",
							value: "Incorporated within this are opportunities unearthed through trigger event business rules. These rules are a curated set of indicators developed by industry experts. They signal the optimal moments and rationales for when a client might be inclined to invest in the next recommended product."
						},
						{
							name: "AI-Driven Opportunities",
							value: "Additionally, the section includes AI-driven opportunities that would typically go unnoticed without the intervention of advanced analytics. This AI model is a powerful asset, extending the advisor's insight beyond traditional methods and revealing hidden prospects for client investment."
						},
						{
							name: "Navigation",
							value: "Advisors can navigate through these opportunities by clicking on the indicated arrow. This action unfolds a detailed breakdown, categorizing opportunities by their origin—be it AI-generated or triggered by specific events. It also segments them based on their propensity to close promptly and their estimated value."
						},
						{
							name: "Ranking System",
							value: "Crucially, all opportunities are ranked to assist advisors in prioritizing their efforts. This ranking is meticulously designed to steer advisors towards opportunities that not only possess high value but also exhibit a shorter timespan for deal closure."
						},
						{
							name: "Purpose",
							value: "The ultimate goal of this section is to equip advisors with a prioritized, insightful view of their book of business, enabling them to concentrate on the most promising and lucrative opportunities for expanding their client's investment portfolio. It's a blend of expert knowledge and machine learning precision, all tailored to enhance the advisor's efficiency and success rate."
						},
					]
				},
			],
			image: "assets/upside_icon.png"
		},
		{
			name: 'Retention Opportunities',
			sub_name: 'Predicted Loss',
			key: 'retention_count',
			sub_key: 'retention_value',
			clickable: true,
			show_analysis: false,
			show_analysis_name: 'Retention Opportunities Analysis',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					name: "The client retention risk section has been designed with a multi-faceted approach to ensure that advisors have a clear and actionable understanding of potential risks within their client base:",
					sub_sections: [
						{
							name: "Section Purpose",
							value: "The purpose of this section is to equip advisors with in-depth knowledge of the risks associated with client retention in their existing portfolios. It's a critical tool aimed at preempting client turnover and fostering long-term loyalty."
						},
						{
							name: "Trigger Event Business Rules Component",
							value: "At the core of this section are the trigger event business rules. These are insights developed by seasoned industry experts that signal potential client departure scenarios. They serve as an early warning system, indicating the possible reasons a client may be contemplating ending their financial services relationship."
						},
						{
							name: "AI-Driven Risk Detection",
							value: "Beyond conventional wisdom, the section is enhanced with AI-driven insights. This sophisticated analysis surfaces risks that would be undetectable without the advanced capabilities of AI, thus offering a deeper understanding of client sentiment and potential disengagement."
						},
						{
							name: "Detailed Risk Analysis",
							value: "Advisors can access a comprehensive breakdown of these risks by interacting with the section. A simple click reveals a detailed categorization of the risks by origin and potential impact. This feature provides a clear view of which clients are at risk and the urgency of addressing their concerns, potentially opening avenues to not only retain but also to expand business with them."
						},
						{
							name: "Prioritization of Risks",
							value: "The risks are prioritized and ranked according to severity and the timeframe within which they may affect the business. This system allows advisors to anticipate and act on retention challenges well in advance, with a 2 to 3-year lead time for strategic action and relationship reinforcement."
						},
						{
							name: "Strategic Benefits",
							value: "This section is more than just a list of risks; it's a strategic asset. It offers the advisors a chance to take preemptive actions based on a comprehensive, data-driven understanding of their client base. By focusing on the highest-ranked risks, advisors can not only secure their business against potential loss but also identify opportunities for additional engagement and revenue through tailored cross-selling strategies."
						},
					]
				},
			],
			image: "assets/retention_icon.png"
		},
		// {
		// 	// name: 'Reassignment - AI Advisor Assistant',
		// 	// name: 'Reassignment - MAGI',
		// 	// name: 'MAGI',
		// 	name: 'MAGI (for existing clients)',
		// 	// sub_name: 'Predicted Opp',
		// 	sub_name: 'Invested AUM',
		// 	key: 'ai_assistant_count',
		// 	sub_key: 'ai_assistant_value',
		// 	clickable: true,
		// 	show_analysis: false,
		// 	// show_analysis_name: 'Reassignment - AI Advisor Assistant Analysis',
		// 	// show_analysis_name: 'Reassignment - MAGI Analysis',
		// 	show_analysis_name: 'MAGI Analysis',
    // format_number: true,
		// 	tooltip: true,
		// 	tooltipText: [
		// 		{
		// 			name: "This section is designed to enhance the efficiency and effectiveness of by leveraging AI technology:",
		// 			sub_sections: [
		// 				{
		// 					name: "Section Purpose",
		// 					value: "This section is created to identify clients within an advisor's book of business who are suitable candidates for reassignment to the AI Advisor Assistant. The objective is to streamline the advisor's workflow, significantly reducing daily tasks by 30 to 60%."
		// 				},
		// 				{
		// 					name: "Benefits of Reassignment",
		// 					value: "By reallocating certain clients to the AI Assistant, can optimize their schedules, allowing them to expand their clientele and elevate the quality of service offered to existing clients. This transition is designed to retain the full spectrum of service benefits while simultaneously granting additional bandwidth for client engagement and business development."
		// 				},
		// 				{
		// 					name: "AI Advisor Assistant Capabilities",
		// 					value: "The AI Advisor Assistant is an advanced system, an amalgam of various AI models, each specializing in distinct areas of client management. These models include:",
		// 					sub_sections: [
		// 						{
		// 						name: "Best Client Interaction Strategy",
		// 						value: "Tailored communication tactics to engage clients effectively."
		// 						},
		// 						{
		// 							name: "Upside Opportunities Identification",
		// 							value: "Recognition of potential areas for financial growth within the client's portfolio."
		// 						},
		// 						{
		// 							name: "Retention Risk Analysis",
		// 							value: "Detection of signals that may indicate a client is at risk of ending their services."
		// 						},
		// 					]
		// 				},
		// 				{
		// 					name: "Training and Performance",
		// 					value: "This feature has undergone extensive training, modeling its approach on the patterns and strategies of high-performing. It analyzes how successful respond to leads and manage retention risks, applying these best practices autonomously to manage routine tasks and client interactions."
		// 				},
		// 				{
		// 					name: "Automation and Efficiency",
		// 					value: "The AI Advisor Assistant is a testament to the power of automation, embodying the capability to take over a substantial portion of the advisor's operational duties. This allows for a more focused and strategic allocation of the advisor's time and expertise, ensuring that clients receive top-tier advisory services while the advisor's practice becomes more scalable and efficient."
		// 				},
		// 			]
		// 		},
		// 	],
		// 	image: "assets/ai_assistant_icon.png"

		// },
		{
			// name: 'Institutional Customers to Deposit Clients',
			name: 'Bank Customers to Deposit Clients',
			sub_name: 'Predicted Opp',
			key: 'new_acquisition',
			sub_key: 'new_acquisition_predicted_value',
			clickable: true,
			show_analysis: false,
			// show_analysis_name: 'Institutional Customers to Deposit Clients Analysis',
			show_analysis_name: 'Bank Customers to Deposit Clients Analysis',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					// name: "The Institutional Customers to Deposit Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
					name: "The Bank Customers to Deposit Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
					sub_sections: [
						// {
						// 	name: "Purpose of the 'Institutional Customers to Deposit Clients Section",
						// 	value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Institutional Customers to Deposit Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
						// },
						{
							name: "Purpose of the Bank Customers to Deposit Clients Section",
							value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Bank Customers to Deposit Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
						},
						{
							name: "Leveraging Existing Relationships",
							value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
						},
						{
							name: "Addressing Industry Gaps",
							value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
						},
						{
							name: "Integration with Traditional Methods",
							value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
						},
						{
							name: "Transforming Banking Clients into Investment Clients",
							value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
						},
						{
							name: "Strategic Advantage",
							// value: "The 'Institutional Customers to Deposit Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
							value: "The 'Bank Customers to Deposit Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
						},
					]
				},
			],
			image: "assets/inst_cross_icon.png"

		},
    {
			name: 'New Prospects',
			sub_name: 'Predicted Opp',
			key: 'new_prospect_acquisition',
			sub_key: 'new_prospect_acquisition_predicted_value',
			clickable: true,
			show_analysis: false,
			show_analysis_name: 'New Prospects Analysis',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					name: "The New Prospects section is crafted to enhance the efficiency of the lead generation and conversion process:",
					sub_sections: [
						{
							name: "Purpose of the New Prospects Section",
							value: "The core purpose of this section is to streamline the identification, engagement, and conversion of New Prospects into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
						},
						{
							name: "Leveraging Existing Relationships",
							value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
						},
						{
							name: "Addressing Industry Gaps",
							value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
						},
						{
							name: "Integration with Traditional Methods",
							value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
						},
						{
							name: "Transforming Banking Clients into Investment Clients",
							value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
						},
						{
							name: "Strategic Advantage",
							value: "The 'New Prospects section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
						},
					]
				},
			],
			image: "assets/inst_cross_icon.png"

		},
		// {
		// 	name: 'Non Customers',
		// 	sub_name: 'Predicted Opp',
		// 	key: 'non_members',
		// 	sub_key: 'non_members_predicted_value',
		// 	clickable: true,
		// 	show_analysis: true,
		// 	show_analysis_name: 'Non Customers Analysis',
		// 	format_number: true,
		// 	tooltip: true,
		// 	tooltipText: [
		// 		{
		// 			name: "The Non Customers section is crafted to enhance the efficiency of the lead generation and conversion process:",
		// 			sub_sections: [
		// 				{
		// 					name: "Purpose of the Non Customers Section",
		// 					value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Non Customers into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
		// 				},
		// 				{
		// 					name: "Leveraging Existing Relationships",
		// 					value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
		// 				},
		// 				{
		// 					name: "Addressing Industry Gaps",
		// 					value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
		// 				},
		// 				{
		// 					name: "Integration with Traditional Methods",
		// 					value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
		// 				},
		// 				{
		// 					name: "Transforming Banking Clients into Investment Clients",
		// 					value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
		// 				},
		// 				{
		// 					name: "Strategic Advantage",
		// 					value: "The 'Non Customers section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
		// 				},
		// 			]
		// 		},
		// 	],
		// 	image: "assets/afa_icon.png"

		// },
  	];
	marketing_team_opp_risks_data: any = [
		{
			// name: 'Institutional Customers to Investment Clients',
			name: 'Bank Customers to Investment Clients',
			sub_name: 'Predicted Opp',
			key: 'new_acquisition',
			sub_key: 'new_acquisition_predicted_value',
			clickable: true,
			show_analysis: false,
			// show_analysis_name: 'Institutional Customers to Investment Clients Analysis',
			show_analysis_name: 'Bank Customers to Investment Clients Analysis',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					// name: "The Institutional Customers to Investment Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
					name: "The Bank Customers to Investment Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
					sub_sections: [
						// {
						// 	name: "Purpose of the 'Institutional Customers to Investment Clients Section",
						// 	value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Institutional Customers to Investment Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
						// },
						{
							name: "Purpose of the Bank Customers to Investment Clients Section",
							value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Bank Customers to Investment Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
						},
						{
							name: "Leveraging Existing Relationships",
							value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
						},
						{
							name: "Addressing Industry Gaps",
							value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
						},
						{
							name: "Integration with Traditional Methods",
							value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
						},
						{
							name: "Transforming Banking Clients into Investment Clients",
							value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
						},
						{
							name: "Strategic Advantage",
							// value: "The 'Institutional Customers to Investment Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
							value: "The 'Bank Customers to Investment Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
						},
					]
				},
			],
			image: "assets/inst_cross_icon.png"

		},
		{
			name: 'New Prospects - Investments',
			sub_name: 'Predicted Opp',
			key: 'new_prospect_acquisition',
			sub_key: 'new_prospect_acquisition_predicted_value',
			clickable: true,
			show_analysis: false,
			show_analysis_name: 'New Prospects Analysis - Investments',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					name: "The New Prospects section is crafted to enhance the efficiency of the lead generation and conversion process:",
					sub_sections: [
						{
							name: "Purpose of the New Prospects Section",
							value: "The core purpose of this section is to streamline the identification, engagement, and conversion of New Prospects into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
						},
						{
							name: "Leveraging Existing Relationships",
							value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
						},
						{
							name: "Addressing Industry Gaps",
							value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
						},
						{
							name: "Integration with Traditional Methods",
							value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
						},
						{
							name: "Transforming Banking Clients into Investment Clients",
							value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
						},
						{
							name: "Strategic Advantage",
							value: "The 'New Prospects section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
						},
					]
				},
			],
			image: "assets/inst_cross_icon.png"

		},
		{
			// name: 'Institutional Customers to Deposit Clients',
			name: 'Bank Customers to Deposit Clients',
			sub_name: 'Predicted Opp',
			// key: 'new_acquisition',
			// sub_key: 'new_acquisition_predicted_value',
			key: 'deposit_opportunities',
			sub_key: 'deposit_predicted_value',
			clickable: true,
			show_analysis: false,
			// show_analysis_name: 'Institutional Customers to Deposit Clients Analysis',
			show_analysis_name: 'Bank Customers to Deposit Clients Analysis',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					// name: "The Institutional Customers to Deposit Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
					name: "The Bank Customers to Deposit Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
					sub_sections: [
						// {
						// 	name: "Purpose of the 'Institutional Customers to Deposit Clients Section",
						// 	value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Institutional Customers to Deposit Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
						// },
						{
							name: "Purpose of the Bank Customers to Deposit Clients Section",
							value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Bank Customers to Deposit Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
						},
						{
							name: "Leveraging Existing Relationships",
							value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
						},
						{
							name: "Addressing Industry Gaps",
							value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
						},
						{
							name: "Integration with Traditional Methods",
							value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
						},
						{
							name: "Transforming Banking Clients into Investment Clients",
							value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
						},
						{
							name: "Strategic Advantage",
							// value: "The 'Institutional Customers to Deposit Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
							value: "The 'Bank Customers to Deposit Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
						},
					]
				},
			],
			image: "assets/inst_cross_icon.png"

		},
    	{
			name: 'New Prospects - Deposits',
			sub_name: 'Predicted Opp',
			key: 'non_members',
			sub_key: 'non_members_predicted_value',
			clickable: true,
			show_analysis: false,
			show_analysis_name: 'New Prospects Analysis - Deposits',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					name: "The New Prospects - Deposits section is crafted to enhance the efficiency of the lead generation and conversion process:",
					sub_sections: [
						{
							name: "Purpose of the New Prospects - Deposits Section",
							value: "The core purpose of this section is to streamline the identification, engagement, and conversion of New Prospects - Deposits into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
						},
						{
							name: "Leveraging Existing Relationships",
							value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
						},
						{
							name: "Addressing Industry Gaps",
							value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
						},
						{
							name: "Integration with Traditional Methods",
							value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
						},
						{
							name: "Transforming Banking Clients into Investment Clients",
							value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
						},
						{
							name: "Strategic Advantage",
							value: "The 'New Prospects - Deposits section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
						},
					]
				},
			],
			image: "assets/afa_icon.png"

		},
    	{
			name: 'Bank Customers to Lending Clients',
			sub_name: 'Predicted Opp',
			key: 'lending_opportunities',
			sub_key: 'lending_predicted_value',
			clickable: true,
			show_analysis: false,
			show_analysis_name: 'Lending Opportunities Analysis',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					// name: "The Institutional Customers to Deposit Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
					name: "The Bank Customers to Lending Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
					sub_sections: [
						// {
						// 	name: "Purpose of the 'Institutional Customers to Deposit Clients Section",
						// 	value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Institutional Customers to Deposit Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
						// },
						{
							name: "Purpose of the Bank Customers to Lending Clients Section",
							value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Bank Customers to Deposit Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
						},
						{
							name: "Leveraging Existing Relationships",
							value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
						},
						{
							name: "Addressing Industry Gaps",
							value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
						},
						{
							name: "Integration with Traditional Methods",
							value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
						},
						{
							name: "Transforming Banking Clients into Lending Clients",
							value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
						},
						{
							name: "Strategic Advantage",
							// value: "The 'Institutional Customers to Deposit Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
							value: "The 'Bank Customers to Insurance Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
						},
					]
				},
			],
			image: "assets/retention_icon.png"
		},
		{
			name: 'New Prospects - Lending',
			sub_name: 'Predicted Opp',
			key: 'non_lending',
			sub_key: 'non_lending_predicted_value',
      // key: 'non_members',
			// sub_key: 'non_members_predicted_value',
			clickable: true,
			show_analysis: false,
			show_analysis_name: 'New Prospects Analysis - Lending',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					name: "The New Prospects - Lending section is crafted to enhance the efficiency of the lead generation and conversion process:",
					sub_sections: [
						{
							name: "Purpose of the New Prospects - Lending Section",
							value: "The core purpose of this section is to streamline the identification, engagement, and conversion of New Prospects - Lending into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
						},
						{
							name: "Leveraging Existing Relationships",
							value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
						},
						{
							name: "Addressing Industry Gaps",
							value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
						},
						{
							name: "Integration with Traditional Methods",
							value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
						},
						{
							name: "Transforming Banking Clients into Investment Clients",
							value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
						},
						{
							name: "Strategic Advantage",
							value: "The 'New Prospects - Lending section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
						},
					]
				},
			],
			image: "assets/afa_icon.png"

		},
    	{
			name: 'Bank Customers to Insurance Clients',
			sub_name: 'Predicted Opp',
			key: 'insurance_opportunities',
			sub_key: 'insurance_predicted_value',
			clickable: true,
			show_analysis: false,
			show_analysis_name: 'Insurance Opportunities Analysis',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					// name: "The Institutional Customers to Deposit Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
					name: "The Bank Customers to Insurance Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
					sub_sections: [
						// {
						// 	name: "Purpose of the 'Institutional Customers to Deposit Clients Section",
						// 	value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Institutional Customers to Deposit Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
						// },
						{
							name: "Purpose of the Bank Customers to Insurance Clients Section",
							value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Bank Customers to Deposit Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
						},
						{
							name: "Leveraging Existing Relationships",
							value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
						},
						{
							name: "Addressing Industry Gaps",
							value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
						},
						{
							name: "Integration with Traditional Methods",
							value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
						},
						{
							name: "Transforming Banking Clients into Insurance Clients",
							value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
						},
						{
							name: "Strategic Advantage",
							// value: "The 'Institutional Customers to Deposit Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
							value: "The 'Bank Customers to Insurance Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
						},
					]
				},
			],
			image: "assets/afa_icon.png"

		},
		{
			name: 'New Prospects - Insurance',
			sub_name: 'Predicted Opp',
			key: 'non_insurance',
			sub_key: 'non_insurance_predicted_value',
      // key: 'non_members',
			// sub_key: 'non_members_predicted_value',
			clickable: true,
			show_analysis: false,
			show_analysis_name: 'New Prospects Analysis - Insurance',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					name: "The New Prospects - Insurance section is crafted to enhance the efficiency of the lead generation and conversion process:",
					sub_sections: [
						{
							name: "Purpose of the New Prospects - Insurance Section",
							value: "The core purpose of this section is to streamline the identification, engagement, and conversion of New Prospects - Insurance into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
						},
						{
							name: "Leveraging Existing Relationships",
							value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
						},
						{
							name: "Addressing Industry Gaps",
							value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
						},
						{
							name: "Integration with Traditional Methods",
							value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
						},
						{
							name: "Transforming Banking Clients into Investment Clients",
							value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
						},
						{
							name: "Strategic Advantage",
							value: "The 'New Prospects - Insurance section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
						},
					]
				},
			],
			image: "assets/afa_icon.png"

		},
  	];

    lending_officer_opp_risks_data: any = [
		{
			name: 'Upside Opportunities',
			sub_name: 'Predicted Opp',
			key: 'upside_opp_count',
			sub_key: 'upside_opp_value',
			clickable: true,
			show_analysis: false,
			show_analysis_name: 'Upside Opportunities Analysis',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					name: "The definition for the section detailing the total upside opportunities within an advisor's existing book of business can be broken down into several parts for clarity:",
					sub_sections: [
						{
							name: "Overview",
							value: "This section is crafted to enlighten advisors on the breadth of untapped opportunities residing within their current book of business. It's a strategic tool designed to spotlight potential areas of growth and client engagement."
						},
						{
							name: "Trigger Event Business Rules",
							value: "Incorporated within this are opportunities unearthed through trigger event business rules. These rules are a curated set of indicators developed by industry experts. They signal the optimal moments and rationales for when a client might be inclined to invest in the next recommended product."
						},
						{
							name: "AI-Driven Opportunities",
							value: "Additionally, the section includes AI-driven opportunities that would typically go unnoticed without the intervention of advanced analytics. This AI model is a powerful asset, extending the advisor's insight beyond traditional methods and revealing hidden prospects for client investment."
						},
						{
							name: "Navigation",
							value: "Advisors can navigate through these opportunities by clicking on the indicated arrow. This action unfolds a detailed breakdown, categorizing opportunities by their origin—be it AI-generated or triggered by specific events. It also segments them based on their propensity to close promptly and their estimated value."
						},
						{
							name: "Ranking System",
							value: "Crucially, all opportunities are ranked to assist advisors in prioritizing their efforts. This ranking is meticulously designed to steer advisors towards opportunities that not only possess high value but also exhibit a shorter timespan for deal closure."
						},
						{
							name: "Purpose",
							value: "The ultimate goal of this section is to equip advisors with a prioritized, insightful view of their book of business, enabling them to concentrate on the most promising and lucrative opportunities for expanding their client's investment portfolio. It's a blend of expert knowledge and machine learning precision, all tailored to enhance the advisor's efficiency and success rate."
						},
					]
				},
			],
			image: "assets/upside_icon.png"
		},
		// {
		// 	name: 'Retention Opportunities',
		// 	sub_name: 'Predicted Loss',
		// 	key: 'retention_count',
		// 	sub_key: 'retention_value',
		// 	clickable: true,
		// 	show_analysis: true,
		// 	show_analysis_name: 'Retention Opportunities Analysis',
    // format_number: true,
		// 	tooltip: true,
		// 	tooltipText: [
		// 		{
		// 			name: "The client retention risk section has been designed with a multi-faceted approach to ensure that advisors have a clear and actionable understanding of potential risks within their client base:",
		// 			sub_sections: [
		// 				{
		// 					name: "Section Purpose",
		// 					value: "The purpose of this section is to equip advisors with in-depth knowledge of the risks associated with client retention in their existing portfolios. It's a critical tool aimed at preempting client turnover and fostering long-term loyalty."
		// 				},
		// 				{
		// 					name: "Trigger Event Business Rules Component",
		// 					value: "At the core of this section are the trigger event business rules. These are insights developed by seasoned industry experts that signal potential client departure scenarios. They serve as an early warning system, indicating the possible reasons a client may be contemplating ending their financial services relationship."
		// 				},
		// 				{
		// 					name: "AI-Driven Risk Detection",
		// 					value: "Beyond conventional wisdom, the section is enhanced with AI-driven insights. This sophisticated analysis surfaces risks that would be undetectable without the advanced capabilities of AI, thus offering a deeper understanding of client sentiment and potential disengagement."
		// 				},
		// 				{
		// 					name: "Detailed Risk Analysis",
		// 					value: "Advisors can access a comprehensive breakdown of these risks by interacting with the section. A simple click reveals a detailed categorization of the risks by origin and potential impact. This feature provides a clear view of which clients are at risk and the urgency of addressing their concerns, potentially opening avenues to not only retain but also to expand business with them."
		// 				},
		// 				{
		// 					name: "Prioritization of Risks",
		// 					value: "The risks are prioritized and ranked according to severity and the timeframe within which they may affect the business. This system allows advisors to anticipate and act on retention challenges well in advance, with a 2 to 3-year lead time for strategic action and relationship reinforcement."
		// 				},
		// 				{
		// 					name: "Strategic Benefits",
		// 					value: "This section is more than just a list of risks; it's a strategic asset. It offers the advisors a chance to take preemptive actions based on a comprehensive, data-driven understanding of their client base. By focusing on the highest-ranked risks, advisors can not only secure their business against potential loss but also identify opportunities for additional engagement and revenue through tailored cross-selling strategies."
		// 				},
		// 			]
		// 		},
		// 	],
		// 	image: "assets/retention_icon.png"
		// },
		// {
		// 	// name: 'Reassignment - AI Advisor Assistant',
		// 	// name: 'Reassignment - MAGI',
		// 	// name: 'MAGI',
		// 	name: 'MAGI (for existing clients)',
		// 	// sub_name: 'Predicted Opp',
		// 	sub_name: 'Invested AUM',
		// 	key: 'ai_assistant_count',
		// 	sub_key: 'ai_assistant_value',
		// 	clickable: true,
		// 	show_analysis: false,
		// 	// show_analysis_name: 'Reassignment - AI Advisor Assistant Analysis',
		// 	// show_analysis_name: 'Reassignment - MAGI Analysis',
		// 	show_analysis_name: 'MAGI Analysis',
    // format_number: true,
		// 	tooltip: true,
		// 	tooltipText: [
		// 		{
		// 			name: "This section is designed to enhance the efficiency and effectiveness of by leveraging AI technology:",
		// 			sub_sections: [
		// 				{
		// 					name: "Section Purpose",
		// 					value: "This section is created to identify clients within an advisor's book of business who are suitable candidates for reassignment to the AI Advisor Assistant. The objective is to streamline the advisor's workflow, significantly reducing daily tasks by 30 to 60%."
		// 				},
		// 				{
		// 					name: "Benefits of Reassignment",
		// 					value: "By reallocating certain clients to the AI Assistant, can optimize their schedules, allowing them to expand their clientele and elevate the quality of service offered to existing clients. This transition is designed to retain the full spectrum of service benefits while simultaneously granting additional bandwidth for client engagement and business development."
		// 				},
		// 				{
		// 					name: "AI Advisor Assistant Capabilities",
		// 					value: "The AI Advisor Assistant is an advanced system, an amalgam of various AI models, each specializing in distinct areas of client management. These models include:",
		// 					sub_sections: [
		// 						{
		// 						name: "Best Client Interaction Strategy",
		// 						value: "Tailored communication tactics to engage clients effectively."
		// 						},
		// 						{
		// 							name: "Upside Opportunities Identification",
		// 							value: "Recognition of potential areas for financial growth within the client's portfolio."
		// 						},
		// 						{
		// 							name: "Retention Risk Analysis",
		// 							value: "Detection of signals that may indicate a client is at risk of ending their services."
		// 						},
		// 					]
		// 				},
		// 				{
		// 					name: "Training and Performance",
		// 					value: "This feature has undergone extensive training, modeling its approach on the patterns and strategies of high-performing. It analyzes how successful respond to leads and manage retention risks, applying these best practices autonomously to manage routine tasks and client interactions."
		// 				},
		// 				{
		// 					name: "Automation and Efficiency",
		// 					value: "The AI Advisor Assistant is a testament to the power of automation, embodying the capability to take over a substantial portion of the advisor's operational duties. This allows for a more focused and strategic allocation of the advisor's time and expertise, ensuring that clients receive top-tier advisory services while the advisor's practice becomes more scalable and efficient."
		// 				},
		// 			]
		// 		},
		// 	],
		// 	image: "assets/ai_assistant_icon.png"

		// },
		{
			// name: 'Institutional Customers to Deposit Clients',
			name: 'Bank Customers to Lending Clients',
			sub_name: 'Predicted Opp',
			key: 'new_acquisition',
			sub_key: 'new_acquisition_predicted_value',
			clickable: true,
			show_analysis: false,
			// show_analysis_name: 'Institutional Customers to Deposit Clients Analysis',
			show_analysis_name: 'Bank Customers to Lending Clients Analysis',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					// name: "The Institutional Customers to Deposit Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
					name: "The Bank Customers to Lending Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
					sub_sections: [
						// {
						// 	name: "Purpose of the 'Institutional Customers to Lending Clients Section",
						// 	value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Institutional Customers to Lending Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
						// },
						{
							name: "Purpose of the Bank Customers to Lending Clients Section",
							value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Bank Customers to Lending Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
						},
						{
							name: "Leveraging Existing Relationships",
							value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
						},
						{
							name: "Addressing Industry Gaps",
							value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
						},
						{
							name: "Integration with Traditional Methods",
							value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
						},
						{
							name: "Transforming Banking Clients into Investment Clients",
							value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
						},
						{
							name: "Strategic Advantage",
							// value: "The 'Institutional Customers to Lending Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
							value: "The 'Bank Customers to Lending Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
						},
					]
				},
			],
			image: "assets/inst_cross_icon.png"

		},
    {
			name: 'New Prospects',
			sub_name: 'Predicted Opp',
			key: 'new_prospect_acquisition',
			sub_key: 'new_prospect_acquisition_predicted_value',
			clickable: true,
			show_analysis: false,
			show_analysis_name: 'New Prospects Analysis',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					name: "The New Prospects section is crafted to enhance the efficiency of the lead generation and conversion process:",
					sub_sections: [
						{
							name: "Purpose of the New Prospects Section",
							value: "The core purpose of this section is to streamline the identification, engagement, and conversion of New Prospects into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
						},
						{
							name: "Leveraging Existing Relationships",
							value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
						},
						{
							name: "Addressing Industry Gaps",
							value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
						},
						{
							name: "Integration with Traditional Methods",
							value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
						},
						{
							name: "Transforming Banking Clients into Investment Clients",
							value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
						},
						{
							name: "Strategic Advantage",
							value: "The 'New Prospects section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
						},
					]
				},
			],
			image: "assets/inst_cross_icon.png"

		},
  	];

    insurance_agent_opp_risks_data: any = [
		{
			name: 'Upside Opportunities',
			sub_name: 'Predicted Opp',
			key: 'upside_opp_count',
			sub_key: 'upside_opp_value',
			clickable: true,
			show_analysis: false,
			show_analysis_name: 'Upside Opportunities Analysis',
      		format_number: true,
			tooltip: true,
			tooltipText: [
				{
					name: "The definition for the section detailing the total upside opportunities within an advisor's existing book of business can be broken down into several parts for clarity:",
					sub_sections: [
						{
							name: "Overview",
							value: "This section is crafted to enlighten advisors on the breadth of untapped opportunities residing within their current book of business. It's a strategic tool designed to spotlight potential areas of growth and client engagement."
						},
						{
							name: "Trigger Event Business Rules",
							value: "Incorporated within this are opportunities unearthed through trigger event business rules. These rules are a curated set of indicators developed by industry experts. They signal the optimal moments and rationales for when a client might be inclined to invest in the next recommended product."
						},
						{
							name: "AI-Driven Opportunities",
							value: "Additionally, the section includes AI-driven opportunities that would typically go unnoticed without the intervention of advanced analytics. This AI model is a powerful asset, extending the advisor's insight beyond traditional methods and revealing hidden prospects for client investment."
						},
						{
							name: "Navigation",
							value: "Advisors can navigate through these opportunities by clicking on the indicated arrow. This action unfolds a detailed breakdown, categorizing opportunities by their origin—be it AI-generated or triggered by specific events. It also segments them based on their propensity to close promptly and their estimated value."
						},
						{
							name: "Ranking System",
							value: "Crucially, all opportunities are ranked to assist advisors in prioritizing their efforts. This ranking is meticulously designed to steer advisors towards opportunities that not only possess high value but also exhibit a shorter timespan for deal closure."
						},
						{
							name: "Purpose",
							value: "The ultimate goal of this section is to equip advisors with a prioritized, insightful view of their book of business, enabling them to concentrate on the most promising and lucrative opportunities for expanding their client's investment portfolio. It's a blend of expert knowledge and machine learning precision, all tailored to enhance the advisor's efficiency and success rate."
						},
					]
				},
			],
			image: "assets/upside_icon.png"
		},
		// {
		// 	name: 'Retention Opportunities',
		// 	sub_name: 'Predicted Loss',
		// 	key: 'retention_count',
		// 	sub_key: 'retention_value',
		// 	clickable: true,
		// 	show_analysis: true,
		// 	show_analysis_name: 'Retention Opportunities Analysis',
    // format_number: true,
		// 	tooltip: true,
		// 	tooltipText: [
		// 		{
		// 			name: "The client retention risk section has been designed with a multi-faceted approach to ensure that advisors have a clear and actionable understanding of potential risks within their client base:",
		// 			sub_sections: [
		// 				{
		// 					name: "Section Purpose",
		// 					value: "The purpose of this section is to equip advisors with in-depth knowledge of the risks associated with client retention in their existing portfolios. It's a critical tool aimed at preempting client turnover and fostering long-term loyalty."
		// 				},
		// 				{
		// 					name: "Trigger Event Business Rules Component",
		// 					value: "At the core of this section are the trigger event business rules. These are insights developed by seasoned industry experts that signal potential client departure scenarios. They serve as an early warning system, indicating the possible reasons a client may be contemplating ending their financial services relationship."
		// 				},
		// 				{
		// 					name: "AI-Driven Risk Detection",
		// 					value: "Beyond conventional wisdom, the section is enhanced with AI-driven insights. This sophisticated analysis surfaces risks that would be undetectable without the advanced capabilities of AI, thus offering a deeper understanding of client sentiment and potential disengagement."
		// 				},
		// 				{
		// 					name: "Detailed Risk Analysis",
		// 					value: "Advisors can access a comprehensive breakdown of these risks by interacting with the section. A simple click reveals a detailed categorization of the risks by origin and potential impact. This feature provides a clear view of which clients are at risk and the urgency of addressing their concerns, potentially opening avenues to not only retain but also to expand business with them."
		// 				},
		// 				{
		// 					name: "Prioritization of Risks",
		// 					value: "The risks are prioritized and ranked according to severity and the timeframe within which they may affect the business. This system allows advisors to anticipate and act on retention challenges well in advance, with a 2 to 3-year lead time for strategic action and relationship reinforcement."
		// 				},
		// 				{
		// 					name: "Strategic Benefits",
		// 					value: "This section is more than just a list of risks; it's a strategic asset. It offers the advisors a chance to take preemptive actions based on a comprehensive, data-driven understanding of their client base. By focusing on the highest-ranked risks, advisors can not only secure their business against potential loss but also identify opportunities for additional engagement and revenue through tailored cross-selling strategies."
		// 				},
		// 			]
		// 		},
		// 	],
		// 	image: "assets/retention_icon.png"
		// },
		// {
		// 	// name: 'Reassignment - AI Advisor Assistant',
		// 	// name: 'Reassignment - MAGI',
		// 	// name: 'MAGI',
		// 	name: 'MAGI (for existing clients)',
		// 	// sub_name: 'Predicted Opp',
		// 	sub_name: 'Invested AUM',
		// 	key: 'ai_assistant_count',
		// 	sub_key: 'ai_assistant_value',
		// 	clickable: true,
		// 	show_analysis: false,
		// 	// show_analysis_name: 'Reassignment - AI Advisor Assistant Analysis',
		// 	// show_analysis_name: 'Reassignment - MAGI Analysis',
		// 	show_analysis_name: 'MAGI Analysis',
    // format_number: true,
		// 	tooltip: true,
		// 	tooltipText: [
		// 		{
		// 			name: "This section is designed to enhance the efficiency and effectiveness of by leveraging AI technology:",
		// 			sub_sections: [
		// 				{
		// 					name: "Section Purpose",
		// 					value: "This section is created to identify clients within an advisor's book of business who are suitable candidates for reassignment to the AI Advisor Assistant. The objective is to streamline the advisor's workflow, significantly reducing daily tasks by 30 to 60%."
		// 				},
		// 				{
		// 					name: "Benefits of Reassignment",
		// 					value: "By reallocating certain clients to the AI Assistant, can optimize their schedules, allowing them to expand their clientele and elevate the quality of service offered to existing clients. This transition is designed to retain the full spectrum of service benefits while simultaneously granting additional bandwidth for client engagement and business development."
		// 				},
		// 				{
		// 					name: "AI Advisor Assistant Capabilities",
		// 					value: "The AI Advisor Assistant is an advanced system, an amalgam of various AI models, each specializing in distinct areas of client management. These models include:",
		// 					sub_sections: [
		// 						{
		// 						name: "Best Client Interaction Strategy",
		// 						value: "Tailored communication tactics to engage clients effectively."
		// 						},
		// 						{
		// 							name: "Upside Opportunities Identification",
		// 							value: "Recognition of potential areas for financial growth within the client's portfolio."
		// 						},
		// 						{
		// 							name: "Retention Risk Analysis",
		// 							value: "Detection of signals that may indicate a client is at risk of ending their services."
		// 						},
		// 					]
		// 				},
		// 				{
		// 					name: "Training and Performance",
		// 					value: "This feature has undergone extensive training, modeling its approach on the patterns and strategies of high-performing. It analyzes how successful respond to leads and manage retention risks, applying these best practices autonomously to manage routine tasks and client interactions."
		// 				},
		// 				{
		// 					name: "Automation and Efficiency",
		// 					value: "The AI Advisor Assistant is a testament to the power of automation, embodying the capability to take over a substantial portion of the advisor's operational duties. This allows for a more focused and strategic allocation of the advisor's time and expertise, ensuring that clients receive top-tier advisory services while the advisor's practice becomes more scalable and efficient."
		// 				},
		// 			]
		// 		},
		// 	],
		// 	image: "assets/ai_assistant_icon.png"

		// },
		{
			// name: 'Institutional Customers to Deposit Clients',
			name: 'Bank Customers to Insurance Clients',
			sub_name: 'Predicted Opp',
			key: 'new_acquisition',
			sub_key: 'new_acquisition_predicted_value',
			clickable: true,
			show_analysis: false,
			// show_analysis_name: 'Institutional Customers to Deposit Clients Analysis',
			show_analysis_name: 'Bank Customers to Insurance Clients Analysis',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					// name: "The Institutional Customers to Deposit Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
					name: "The Bank Customers to Insurance Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
					sub_sections: [
						// {
						// 	name: "Purpose of the 'Institutional Customers to Insurance Clients Section",
						// 	value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Institutional Customers to Insurance Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
						// },
						{
							name: "Purpose of the Bank Customers to Insurance Clients Section",
							value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Bank Customers to Insurance Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
						},
						{
							name: "Leveraging Existing Relationships",
							value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
						},
						{
							name: "Addressing Industry Gaps",
							value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
						},
						{
							name: "Integration with Traditional Methods",
							value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
						},
						{
							name: "Transforming Banking Clients into Investment Clients",
							value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
						},
						{
							name: "Strategic Advantage",
							// value: "The 'Institutional Customers to Insurance Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
							value: "The 'Bank Customers to Insurance Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
						},
					]
				},
			],
			image: "assets/inst_cross_icon.png"

		},
    {
			name: 'New Prospects',
			sub_name: 'Predicted Opp',
			key: 'new_prospect_acquisition',
			sub_key: 'new_prospect_acquisition_predicted_value',
			clickable: true,
			show_analysis: false,
			show_analysis_name: 'New Prospects Analysis',
			format_number: true,
			tooltip: true,
			tooltipText: [
				{
					name: "The New Prospects section is crafted to enhance the efficiency of the lead generation and conversion process:",
					sub_sections: [
						{
							name: "Purpose of the New Prospects Section",
							value: "The core purpose of this section is to streamline the identification, engagement, and conversion of New Prospects into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
						},
						{
							name: "Leveraging Existing Relationships",
							value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
						},
						{
							name: "Addressing Industry Gaps",
							value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
						},
						{
							name: "Integration with Traditional Methods",
							value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
						},
						{
							name: "Transforming Banking Clients into Investment Clients",
							value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
						},
						{
							name: "Strategic Advantage",
							value: "The 'New Prospects section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
						},
					]
				},
			],
			image: "assets/inst_cross_icon.png"

		},
  	];

	getKey(data, value) {
		return data[value];
	}

	abbreviateNumber(value) {
		let fixed = 1;
		let num = value;
		if (num === null) {
		return null;
		}
		if (num === 0) {
		return '0';
		}
		fixed = !fixed || fixed < 0 ? 0 : fixed;
		var b = num.toPrecision(2).split('e'),
		k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
		c =
			k < 1
			? num.toFixed(0 + fixed)
			: (num / Math.pow(10, k * 3)).toFixed(1 + fixed),
		d = c < 0 ? c : Math.abs(c),
		e = d + ['', 'K', 'M', 'B', 'T'][k];
		return e;

		// value = Math.round(value);
		// let new_value = value;
		// if (value >= 1000) {
		//     const suffixes = ["", "K", "M", "B","T"];
		//     const suffixNum = Math.floor( (""+value).length/3 );
		//     let shortValue: any = '';
		//     for (var precision = 2; precision >= 1; precision--) {
		//         shortValue = parseFloat( (suffixNum != 0 ? (value / Math.pow(1000,suffixNum) ) : value).toPrecision(precision));
		//         var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g,'');
		//         if (dotLessShortValue.length <= 2) { break; }
		//     }
		//     if (shortValue % 1 != 0)  shortValue = shortValue.toFixed(1);
		//     new_value = shortValue+suffixes[suffixNum];
		// }
		// return new_value;
	}

  	upside_opportunuty_graph_options: any;
	upside_opportunuty_graph: any;
	upside_opportunuty_name: any = "";
	createUpsideOpportunityGraph() {
		let $this = this;
		if ($this.upside_opportunuty_graph) {
			$this.upside_opportunuty_graph.destroy();
		}

		const options = {
			colors: $this.opportunities_data["upside_graph"]['colors'],
			series: $this.opportunities_data["upside_graph"]['data'],
			chart: {
				type: 'pie',
				events: {
					dataPointSelection: function (event, chartContext, config) {
						const details = {
							name: $this.opportunities_data['upside_graph']['labels'][config.dataPointIndex],
						};
						$this.upside_opportunuty_name = $this.upside_opportunuty_name == details.name ? '' : details.name;
					},
				},
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 350,
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
				},
			},
			plotOptions: {
				pie: {
					startAngle: 0
				}
			},
			dataLabels: {
				enabled: false,
			},
			labels: $this.opportunities_data["upside_graph"]['legends'],
			legend: {
				position: 'bottom',
				enabled: false,
			},
			yaxis: {
				title: {
					text: '',
				},
			},
			fill: {
				opacity: 1,
			},
			// tooltip: {
			// 	custom: function ({ series, seriesIndex, dataPointIndex, w }) {
			// 		return (
			// 			'<div style="width:300px; padding:8px">' +
			// 			'<p style="width:100%;text-overflow:clip;white-space:break-spaces">' +
			// 			$this.opportunity_graph_data[$this.selected_top_percentage][$this.selected_analysis_value]['opportunity_graph']['legends'][seriesIndex] +
			// 			'</p>' +
			// 			'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Opportunity</b>: $' +
			// 			$this.commonService.abbreviateNumber($this.opportunity_graph_data[$this.selected_top_percentage][$this.selected_analysis_value]['opportunity_graph']['data'][seriesIndex]) + '(' + $this.opportunity_graph_data[$this.selected_top_percentage][$this.selected_analysis_value]['opportunity_graph']['data_percentage'][seriesIndex] + '% of Total Opportunity)' +
			// 			'</p>' +
			// 			'</div>'
			// 		);
			// 	},
			// 	//  fixed: {
			// 	//   enabled: true,
			// 	//   position: "topRight"
			// 	// }
			// }
		};

		$this.upside_opportunuty_graph = new ApexCharts(document.querySelector('#upside-opportunity-graph'), options);
		$this.upside_opportunuty_graph.render();
	}

  	retention_opportunuty_graph_options: any;
	retention_opportunuty_graph: any;
	retention_opportunuty_name: any = "";
	createRetentionOpportunityGraph() {
		let $this = this;
		if ($this.retention_opportunuty_graph) {
			$this.retention_opportunuty_graph.destroy();
		}

		const options = {
			colors: $this.opportunities_data["retention_graph"]['colors'],
			series: $this.opportunities_data["retention_graph"]['data'],
			chart: {
				type: 'pie',
				events: {
					dataPointSelection: function (event, chartContext, config) {
						const details = {
							name: $this.opportunities_data['upside_graph']['labels'][config.dataPointIndex],
						};
						$this.retention_opportunuty_name = $this.retention_opportunuty_name == details.name ? '' : details.name;
					},
				},
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 350,
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
				},
			},
			plotOptions: {
				pie: {
					startAngle: 0
				}
			},
			dataLabels: {
				enabled: false,
			},
			labels: $this.opportunities_data["retention_graph"]['legends'],
			legend: {
				position: 'bottom',
				enabled: false,
			},
			yaxis: {
				title: {
					text: '',
				},
			},
			fill: {
				opacity: 1,
			},
			// tooltip: {
			// 	custom: function ({ series, seriesIndex, dataPointIndex, w }) {
			// 		return (
			// 			'<div style="width:300px; padding:8px">' +
			// 			'<p style="width:100%;text-overflow:clip;white-space:break-spaces">' +
			// 			$this.opportunity_graph_data[$this.selected_top_percentage][$this.selected_analysis_value]['opportunity_graph']['legends'][seriesIndex] +
			// 			'</p>' +
			// 			'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Opportunity</b>: $' +
			// 			$this.commonService.abbreviateNumber($this.opportunity_graph_data[$this.selected_top_percentage][$this.selected_analysis_value]['opportunity_graph']['data'][seriesIndex]) + '(' + $this.opportunity_graph_data[$this.selected_top_percentage][$this.selected_analysis_value]['opportunity_graph']['data_percentage'][seriesIndex] + '% of Total Opportunity)' +
			// 			'</p>' +
			// 			'</div>'
			// 		);
			// 	},
			// 	//  fixed: {
			// 	//   enabled: true,
			// 	//   position: "topRight"
			// 	// }
			// }
		};

		$this.retention_opportunuty_graph = new ApexCharts(document.querySelector('#retention-opportunity-graph'), options);
		$this.retention_opportunuty_graph.render();
	}


	@ViewChild('upsideOpportunityTriggersModal') upsideOpportunityTriggersModal: TemplateRef<any>;
  	private upsideOpportunityTriggersModalRef: MatDialogRef<TemplateRef<any>>;

	openUpsideOpportunityTriggersModal(type) {
		this.upside_opportunity_trigger_type = type;
		this.getUpsideOpportunityTriggersData();
		this.upsideOpportunityTriggersModalRef = this.dialog.open(this.upsideOpportunityTriggersModal, { disableClose: true });
		this.upsideOpportunityTriggersModalRef.afterClosed().subscribe((result) => {
			this.closeUpsideOpportunityTriggersModal();
		});
	}

	closeUpsideOpportunityTriggersModal() {
		this.upsideOpportunityTriggersModalRef.close();
		this.upside_opportunity_trigger_filter = 'all';
		this.upside_opportunity_trigger_type = '';
		this.upside_opportunity_trigger_data = {};
		this.upside_opportunity_trigger_current_page = 1;
	}

	upside_opportunity_trigger_filter: any = 'all';
	upside_opportunity_trigger_type: any = '';
	upside_opportunity_trigger_data: any;
	upside_opportunity_trigger_current_page: any = 1;
	upside_opportunity_trigger_data_loaded: boolean = false;
	getUpsideOpportunityTriggersData() {
		this.upside_opportunity_trigger_current_page = 1;
		let role: any = "";
		if (this.user_details.role.role == 4) {
			role = "Advisor Manager";
		} else if (this.user_details.role.role == 5) {
			role = "Advisor";
		} else if (this.user_details.role.role == 6) {
			role = "AFA";
		}
		this.upside_opportunity_trigger_data_loaded = false;
		const route = "/activitysummary/?role=" + role + "&opp_type=" + this.upside_opportunity_trigger_type + "&trigger_type=" + this.upside_opportunity_trigger_filter;
		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.upside_opportunity_trigger_data = res;
				this.upside_opportunity_trigger_data_loaded = true;
			},
			(err) => {
				this.upside_opportunity_trigger_data_loaded = true;
				this.commonService.showToast('error', err.error);
			},
		);
	}

}

